import type { LeadMagnet } from "./leadMagnets";

// Auto-generated translations. Do not edit by hand; regenerate with
// scripts/translate-leadmagnets.ts
export const leadMagnets_el: LeadMagnet[] = [
  {
    "slug": "build-your-own-tool-instead-of-saas",
    "eyebrow": "// own_it",
    "title": "Αποκτήστε το εργαλείο σας. [[Σταματήστε να «νοικιάζετε» την επιχείρησή σας.]]",
    "subtitle": "Κάθε μήνα πληρώνετε για SaaS που δεν ελέγχετε — τον οδικό του χάρτη, τις αυξήσεις τιμών, τους περιορισμούς του. Εμείς αναπτύσσουμε λογισμικό που σας ανήκει πλήρως: διαμορφωμένο γύρω από τον τρόπο που πραγματικά εργάζεστε, ελεύθερο να εξελιχθεί και δικό σας για πάντα.",
    "metaTitle": "Δημιουργήστε το δικό σας εργαλείο αντί να πληρώνετε για SaaS | DevCore",
    "metaDescription": "Κουραστήκατε από τους περιορισμούς του SaaS, τις τιμές ανά χρήστη και τον οδικό χάρτη κάποιου άλλου; Η DevCore δημιουργεί προσαρμοσμένο λογισμικό που σας ανήκει — ευέλικτο, επεκτάσιμο και διαμορφωμένο γύρω από την επιχείρησή σας.",
    "stats": [
      {
        "value": "100%",
        "label": "ιδιοκτησία κώδικα & δεδομένων"
      },
      {
        "value": "0",
        "label": "χρεώσεις ανά θέση εργασίας καθώς μεγαλώνετε"
      },
      {
        "value": "∞",
        "label": "λειτουργίες που μπορείτε να προσθέσετε"
      }
    ],
    "problemKicker": "// the_trap",
    "problemTitle": "Το SaaS φαίνεται φθηνό — μέχρι να γίνει ο ιδιοκτήτης της επιχείρησής σας",
    "problemBody": "Τα έτοιμα εργαλεία ξεκινούν ως βολικά και καταλήγουν να σας ελέγχουν. Προσαρμόζετε τη διαδικασία σας για να ταιριάζει στο λογισμικό τους, πληρώνετε περισσότερο κάθε φορά που προσθέτετε ένα άτομο και περιμένετε λειτουργίες που μπορεί να μην εφαρμοστούν ποτέ. Η συνδρομή δεν τελειώνει ποτέ και δεν σας ανήκει ποτέ τίποτα.",
    "problemPoints": [
      "Τιμολόγηση ανά θέση που σας τιμωρεί για την ανάπτυξη",
      "Κρίσιμες λειτουργίες κολλημένες σε έναν οδικό χάρτη που δεν μπορείτε να επηρεάσετε",
      "Τα δεδομένα σας κλειδωμένα στην πλατφόρμα κάποιου άλλου",
      "Λύσεις, υπολογιστικά φύλλα και αυτοσχέδιες επιδιορθώσεις για να καλύψετε τα κενά",
      "Απρόοπτες αυξήσεις τιμών χωρίς εναλλακτικές"
    ],
    "pillarsKicker": "// why_own",
    "pillarsTitle": "Τι σας προσφέρει πραγματικά η ιδιοκτησία",
    "pillars": [
      {
        "icon": "Lock",
        "title": "Πραγματική ιδιοκτησία",
        "body": "Σας ανήκει ο κώδικας, τα δεδομένα και η υποδομή. Χωρίς εξάρτηση από προμηθευτή, χωρίς πλατφόρμες που μπορούν να σας αφήσουν ξεκρέμαστους, χωρίς ετήσια λύτρα για να συνεχίσετε να εργάζεστε."
      },
      {
        "icon": "SlidersHorizontal",
        "title": "Σχεδιασμένο γύρω σας",
        "body": "Το λογισμικό ταιριάζει στην ακριβή ροή εργασίας σας — όχι σε έναν γενικό μέσο όρο όλων των άλλων. Κάθε οθόνη, πεδίο και κανόνας αντανακλά τον τρόπο που λειτουργεί πραγματικά η ομάδα σας."
      },
      {
        "icon": "TrendingUp",
        "title": "Επεκτείνεται δωρεάν",
        "body": "Προσθέστε 5 χρήστες ή 500 — το κόστος σας δεν εκτοξεύεται. Πληρώνετε για την ανάπτυξη και τη φιλοξενία, ποτέ φόρο για κάθε νέα θέση."
      },
      {
        "icon": "Puzzle",
        "title": "Ατελείωτα προσαρμόσιμο",
        "body": "Νέα ιδέα τη Δευτέρα, σε λειτουργία μέχρι την Παρασκευή. Το εργαλείο σας αλλάζει όταν αλλάζει η επιχείρησή σας, αντί να περιμένετε στην ουρά ενός προμηθευτή."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Ενοικίαση SaaS vs. ιδιοκτησία του εργαλείου σας",
    "compareLeftLabel": "Γενικό SaaS",
    "compareRightLabel": "Το προσαρμοσμένο σας εργαλείο",
    "compareRows": [
      {
        "label": "Τιμολόγηση",
        "left": "Ανά θέση, για πάντα",
        "right": "Δημιουργία μία φορά, ιδιοκτησία"
      },
      {
        "label": "Εφαρμογή",
        "left": "Εσείς προσαρμόζεστε σε αυτό",
        "right": "Αυτό προσαρμόζεται σε εσάς"
      },
      {
        "label": "Οδικός χάρτης",
        "left": "Κάποιος άλλος αποφασίζει",
        "right": "Εσείς αποφασίζετε"
      },
      {
        "label": "Δεδομένα",
        "left": "Κλειδωμένα στο cloud τους",
        "right": "Δικά σας, οπουδήποτε"
      },
      {
        "label": "Κόστος κλιμάκωσης",
        "left": "Αυξάνεται με τον αριθμό προσωπικού",
        "right": "Ουσιαστικά σταθερό"
      },
      {
        "label": "Ενσωματώσεις",
        "left": "Μόνο ό,τι επιτρέπουν",
        "right": "Ό,τι χρειάζεστε"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Από το χάος των συνδρομών στο ιδιόκτητο λογισμικό",
    "steps": [
      {
        "title": "Καταγραφή της ροής εργασίας σας",
        "body": "Μαθαίνουμε πώς λειτουργεί πραγματικά η επιχείρησή σας και πού πονάει περισσότερο το SaaS stack."
      },
      {
        "title": "Σχεδιασμός του πλάνου",
        "body": "Ένα σαφές σχέδιο του εργαλείου, πεδίο εφαρμογής και κόστος — χωρίς περιττά, χωρίς εκπλήξεις."
      },
      {
        "title": "Ανάπτυξη σε sprints",
        "body": "Λειτουργικό λογισμικό σε εβδομάδες, παραδιδόμενο σε αυξανόμενα διαστήματα που μπορείτε να δείτε και να διαμορφώσετε."
      },
      {
        "title": "Ιδιοκτησία και εξέλιξη",
        "body": "Παίρνετε τα κλειδιά. Μπορούμε να συνεχίσουμε να το βελτιώνουμε ή να το παραδώσουμε πλήρως — είναι δική σας επιλογή."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Ιδιοκτησία vs. ενοικίαση — απαντήσεις",
    "faqs": [
      {
        "q": "Δεν είναι πιο ακριβή η δημιουργία προσαρμοσμένου λογισμικού από το SaaS;",
        "a": "Αρχικά, μερικές φορές ναι. Σε βάθος 2-3 ετών, το προσαρμοσμένο συνήθως κερδίζει — ειδικά όταν οι χρεώσεις ανά θέση, τα πρόσθετα και οι αυξήσεις τιμών του SaaS συσσωρεύονται. Και στο τέλος, κατέχετε ένα περιουσιακό στοιχείο αντί μιας σειράς αποδείξεων."
      },
      {
        "q": "Τι γίνεται αν οι ανάγκες μου αλλάξουν αργότερα;",
        "a": "Αυτός είναι και ο σκοπός. Επειδή σας ανήκει, το εργαλείο εξελίσσεται μαζί σας — νέες λειτουργίες, νέες ροές εργασίας, νέες ενσωματώσεις — σύμφωνα με το δικό σας χρονοδιάγραμμα, όχι ενός προμηθευτή."
      },
      {
        "q": "Χρειάζομαι τεχνική ομάδα για να το λειτουργήσω;",
        "a": "Όχι. Εμείς το φιλοξενούμε, το συντηρούμε και το υποστηρίζουμε για εσάς αν θέλετε, ή παραδίδουμε πλήρη τεκμηρίωση και πρόσβαση αν προτιμάτε να το λειτουργήσετε μόνοι σας."
      },
      {
        "q": "Μπορεί να αντικαταστήσει πολλά εργαλεία ταυτόχρονα;",
        "a": "Συχνά ναι. Η ενοποίηση 3-5 αλληλεπικαλυπτόμενων συνδρομών σε ένα εργαλείο που ταιριάζει απόλυτα είναι ένα από τα πιο κοινά — και πιο κερδοφόρα — έργα που αναλαμβάνουμε."
      },
      {
        "q": "Πόσο καιρό χρειάζεται μέχρι να δω κάτι πραγματικό;",
        "a": "Συνήθως μερικές εβδομάδες για μια πρώτη λειτουργική έκδοση. Χτίζουμε σε επανάληψεις, ώστε να μην περιμένετε ποτέ μήνες για να δείτε πρόοδο."
      }
    ],
    "ctaTitle": "Σταματήστε να νοικιάζετε. Ξεκινήστε να κατέχετε.",
    "ctaBody": "Πείτε μας ποιες συνδρομές SaaS κρατούν πίσω την επιχείρησή σας. Θα σας δείξουμε πώς θα μπορούσε να μοιάζει η κατοχή του σωστού εργαλείου."
  },
  {
    "slug": "custom-crm",
    "eyebrow": "// your_crm",
    "title": "Ένα CRM που σας ταιριάζει — [[όχι το αντίστροφο.]]",
    "subtitle": "Το Salesforce είναι φουσκωμένο. Το HubSpot είναι άκαμπτο. Τα 'απλά' είναι πολύ απλά. Δημιουργούμε ένα CRM γύρω από την πραγματική σας διαδικασία πωλήσεων — κάθε pipeline, πεδίο και αυτοματοποίηση ακριβώς όπως πουλάει η ομάδα σας.",
    "metaTitle": "Ανάπτυξη Προσαρμοσμένου CRM — Καλύτερο από έτοιμο | DevCore",
    "metaDescription": "Τα γενικά CRM αναγκάζουν την ομάδα σας να προσαρμοστεί. Η DevCore δημιουργεί ένα προσαρμοσμένο CRM γύρω από την ακριβή σας διαδικασία πωλήσεων, αυτοματοποιήσεις και δεδομένα — χωρίς περιττά, χωρίς χρέωση ανά χρήστη, χωρίς συμβιβασμούς.",
    "stats": [
      {
        "value": "1",
        "label": "CRM προσαρμοσμένο στη διαδικασία σας"
      },
      {
        "value": "0",
        "label": "αχρησιμοποίητες λειτουργίες για πληρωμή"
      },
      {
        "value": "100%",
        "label": "τα δεδομένα σας, οι κανόνες σας"
      }
    ],
    "problemKicker": "// the_struggle",
    "problemTitle": "Το CRM σας πρέπει να σας βοηθά να πουλάτε — όχι να σας επιβραδύνει",
    "problemBody": "Οι περισσότερες ομάδες είτε πνίγονται σε ένα CRM που κάνει πολλά είτε ξεπερνούν ένα που κάνει λίγα. Έτσι ζουν σε υπολογιστικά φύλλα, χάνουν συμφωνίες στις ρωγμές και πληρώνουν για εκατοντάδες λειτουργίες που δεν θα χρησιμοποιήσουν ποτέ.",
    "problemPoints": [
      "Διαδικασίες πωλήσεων (pipelines) που δεν ταιριάζουν με τον τρόπο που πουλάτε στην πραγματικότητα",
      "Ώρες χαμένες σε χειροκίνητη εισαγωγή δεδομένων και αντιγραφή-επικόλληση",
      "Τιμολόγηση ανά χρήστη που κάνει την ανάπτυξη της ομάδας επώδυνη",
      "Αναφορές που ποτέ δεν απαντούν στην ερώτηση που κάνετε",
      "Η μισή διαδικασία σας ζει ακόμα σε υπολογιστικά φύλλα"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Ένα CRM χτισμένο για το πώς πουλάει πραγματικά η ομάδα σας",
    "pillars": [
      {
        "icon": "Workflow",
        "title": "Η ακριβής σας ροή εργασίας (pipeline)",
        "body": "Στάδια, πεδία και κανόνες που αντικατοπτρίζουν την πραγματική σας διαδικασία πωλήσεων — όχι ένα γενικό πρότυπο που πρέπει να προσαρμόσετε με κόπο."
      },
      {
        "icon": "Zap",
        "title": "Αυτοματοποίηση που ταιριάζει",
        "body": "Follow-ups, μεταφορές, υπενθυμίσεις και εισαγωγή δεδομένων διεκπεραιώνονται αυτόματα, ακριβώς εκεί που τις χρειάζεται η διαδικασία σας."
      },
      {
        "icon": "Database",
        "title": "Μία πηγή αλήθειας",
        "body": "Επαφές, συμφωνίες, προσφορές, emails και ιστορικό σε ένα μέρος — συνδεδεμένο με τα υπόλοιπα εργαλεία σας, όχι απομονωμένο."
      },
      {
        "icon": "Gauge",
        "title": "Αναφορές που απαντούν",
        "body": "Dashboards σχεδιασμένα γύρω από τις αποφάσεις που παίρνετε πραγματικά, με τις μετρήσεις που έχουν σημασία για την επιχείρησή σας."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Έτοιμο CRM έναντι ενός δικού σας CRM",
    "compareLeftLabel": "Γενικό CRM",
    "compareRightLabel": "Το δικό σας προσαρμοσμένο CRM",
    "compareRows": [
      {
        "label": "Ροή εργασίας",
        "left": "Σταθερά πρότυπα",
        "right": "Χτισμένο στη διαδικασία σας"
      },
      {
        "label": "Λειτουργίες",
        "left": "Πληρώνετε για 100, χρησιμοποιείτε 10",
        "right": "Ακριβώς ό,τι χρειάζεστε"
      },
      {
        "label": "Τιμολόγηση",
        "left": "Ανά χρήστη ανά μήνα",
        "right": "Το κατέχετε, κλιμακώστε ελεύθερα"
      },
      {
        "label": "Αυτοματοποίηση",
        "left": "Περιορισμένη / επί πληρωμή",
        "right": "Προσαρμοσμένη σε εσάς"
      },
      {
        "label": "Δεδομένα",
        "left": "Το cloud τους, οι κανόνες τους",
        "right": "Δικά σας, πλήρως φορητά"
      },
      {
        "label": "Ενσωματώσεις",
        "left": "Ρουλέτα αγοράς",
        "right": "Ό,τι κι αν χρησιμοποιείτε"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Από το χάος των υπολογιστικών φύλλων σε ένα CRM που θα λατρέψετε",
    "steps": [
      {
        "title": "Παρακολουθούμε τις πωλήσεις σας",
        "body": "Χαρτογραφούμε πώς κινούνται πραγματικά οι δυνητικοί πελάτες από την πρώτη επαφή μέχρι την κλεισμένη συμφωνία."
      },
      {
        "title": "Σχεδιάζουμε τη ροή εργασίας (pipeline)",
        "body": "Ένα σχέδιο με στάδια, πεδία, αυτοματοποιήσεις και αναφορές — συμφωνημένα πριν την υλοποίηση."
      },
      {
        "title": "Κατασκευή & Μετανάστευση",
        "body": "Το παραδίδουμε σε sprints και μεταφέρουμε τα υπάρχοντα δεδομένα σας με καθαρό τρόπο."
      },
      {
        "title": "Εφαρμογή & Βελτίωση",
        "body": "Η ομάδα σας το υιοθετεί γρήγορα γιατί λειτουργεί όπως ήδη λειτουργεί."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Custom CRM — απαντήσεις",
    "faqs": [
      {
        "q": "Μπορείτε να μεταφέρετε τα δεδομένα μας από το τρέχον CRM ή τα υπολογιστικά φύλλα μας;",
        "a": "Ναι. Η καθαρή μετανάστευση από Salesforce, HubSpot, Pipedrive, Excel ή Google Sheets αποτελεί μέρος του έργου, ώστε τίποτα να μην μείνει πίσω."
      },
      {
        "q": "Θα ενσωματωθεί με το email, το ημερολόγιο και τα άλλα εργαλεία μας;",
        "a": "Οπωσδήποτε. Email, ημερολόγιο, τιμολόγηση, υποστήριξη, marketing — συνδέουμε το CRM με τα εργαλεία που ήδη χρησιμοποιείτε."
      },
      {
        "q": "Αξίζει πραγματικά ένα προσαρμοσμένο CRM σε σχέση με το HubSpot ή το Salesforce;",
        "a": "Εάν η διαδικασία σας είναι μη τυπική ή οι χρεώσεις ανά χρήστη γίνονται επώδυνες, ναι. Αποκτάτε ένα εργαλείο που ταιριάζει ακριβώς και ένα περιουσιακό στοιχείο που κατέχετε αντί για μια συνεχώς αυξανόμενη συνδρομή."
      },
      {
        "q": "Πόσο χρόνο χρειάζεται για να κατασκευαστεί;",
        "a": "Μια στοχευμένη πρώτη έκδοση είναι συνήθως διαθέσιμη σε λίγες εβδομάδες. Στη συνέχεια την επεκτείνουμε με βάση το πώς τη χρησιμοποιεί η ομάδα σας καθημερινά."
      },
      {
        "q": "Μπορεί να αναπτυχθεί μαζί μας;",
        "a": "Αυτό είναι το πλεονέκτημα του να το κατέχετε. Νέες ροές εργασίας, ομάδες, περιοχές ή σειρές προϊόντων προστίθενται όταν τις χρειάζεστε — χωρίς να χρειάζεται αλλαγή πλατφόρμας."
      }
    ],
    "ctaTitle": "Φτιάξτε το CRM που η ομάδα σας θα χρησιμοποιεί πραγματικά.",
    "ctaBody": "Πείτε μας πώς πουλάτε. Θα σας δείξουμε ένα CRM σχεδιασμένο γύρω από τη ροή εργασίας σας — όχι το πρότυπο κάποιου άλλου."
  },
  {
    "slug": "build-an-app-without-headaches",
    "eyebrow": "// no_headaches",
    "title": "Δημιουργήστε την εφαρμογή σας [[χωρίς πονοκεφάλους.]]",
    "subtitle": "Ασαφείς προσφορές, χαμένες προθεσμίες, πρακτορεία που εξαφανίζονται, κώδικας που δεν μπορείτε να διαβάσετε. Η δημιουργία μιας εφαρμογής δεν πρέπει να μοιάζει με τζόγο. Με μια ανώτερη ομάδα και ένα σαφές σχέδιο, δεν είναι.",
    "metaTitle": "Δημιουργία Εφαρμογής χωρίς Πονοκεφάλους — Από Ειδικούς | DevCore",
    "metaDescription": "Αποφύγετε τις χαμένες προθεσμίες, τους απρόσμενους λογαριασμούς και τον ακατάστατο κώδικα. Η DevCore κατασκευάζει την εφαρμογή σας (web ή mobile) με έμπειρους μηχανικούς, ένα σαφές σχέδιο και λογισμικό που πραγματικά σας ανήκει.",
    "stats": [
      {
        "value": "1",
        "label": "ανώτερη ομάδα, από την αρχή μέχρι το τέλος"
      },
      {
        "value": "0",
        "label": "αναμενόμενα τιμολόγια"
      },
      {
        "value": "100%",
        "label": "καθαρός, τεκμηριωμένος κώδικας"
      }
    ],
    "problemKicker": "// the_headache",
    "problemTitle": "Γιατί τα περισσότερα έργα εφαρμογών πάνε στραβά",
    "problemBody": "Έχετε ακούσει ιστορίες τρόμου — ή τις έχετε ζήσει. Προϋπολογισμοί που διπλασιάζονται, χρονοδιαγράμματα που καθυστερούν, ένα MVP που είναι χάλια κάτω από την επιφάνεια. Το πρόβλημα συνήθως δεν είναι η ιδέα. Είναι η έλλειψη σαφούς σχεδίου και μιας ομάδας που πραγματικά αναλαμβάνει την ευθύνη για το αποτέλεσμα.",
    "problemPoints": [
      "Προσφορές που εκτοξεύονται στα μέσα της κατασκευής",
      "Προθεσμίες που καθυστερούν χωρίς σαφή λόγο",
      "Κώδικας τόσο ακατάστατος που ο επόμενος προγραμματιστής πρέπει να ξεκινήσει από την αρχή",
      "Γραφεία που σιωπούν τη στιγμή που τα πράγματα δυσκολεύουν",
      "Μια εφαρμογή που λειτουργεί τεχνικά αλλά κανείς δεν απολαμβάνει να χρησιμοποιεί"
    ],
    "pillarsKicker": "// how_it_should_be",
    "pillarsTitle": "Πώς είναι η κατασκευή με επαγγελματίες",
    "pillars": [
      {
        "icon": "FileText",
        "title": "Ένα σαφές σχέδιο πρώτα",
        "body": "Πριν από μία γραμμή κώδικα, έχετε ένα σχέδιο: πεδίο εφαρμογής, χρονοδιάγραμμα και έναν σταθερό, ειλικρινή προϋπολογισμό. Καθόλου εικασίες, καθόλου αιφνίδιες αλλαγές στο εύρος."
      },
      {
        "icon": "Code2",
        "title": "Μόνο έμπειροι μηχανικοί",
        "body": "Το έργο σας δεν ανατίθεται σε αρχάριους. Οι έμπειροι κατασκευαστές κάνουν τις σωστές επιλογές νωρίς — αυτές που σας εξοικονομούν μήνες αργότερα."
      },
      {
        "icon": "Eye",
        "title": "Πλήρης διαφάνεια",
        "body": "Παρακολουθήστε την πρόοδο κάθε εβδομάδα με λειτουργικό λογισμικό, όχι απλές αναφορές. Ξέρετε πάντα πού βρίσκονται τα πράγματα."
      },
      {
        "icon": "Rocket",
        "title": "Εξελιγμένο & δικό σας",
        "body": "Γρήγορο, όμορφο, αξιόπιστο — και πλήρως δικό σας, με καθαρό κώδικα και τεκμηρίωση ώστε να μην είστε ποτέ όμηροι."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Τυπικό πρακτορείο vs. κατασκευή με DevCore",
    "compareLeftLabel": "Τυπική εμπειρία",
    "compareRightLabel": "Με DevCore",
    "compareRows": [
      {
        "label": "Τιμολόγηση",
        "left": "Ασαφής, μετά αυξάνεται",
        "right": "Σαφής & σταθερή εκ των προτέρων"
      },
      {
        "label": "Ομάδα",
        "left": "Εξωτερικοί junior",
        "right": "Έμπειροι μηχανικοί"
      },
      {
        "label": "Πρόοδος",
        "left": "Αναφορές κατάστασης",
        "right": "Λειτουργικό λογισμικό εβδομαδιαίως"
      },
      {
        "label": "Κώδικας",
        "left": "Ακατάστατος, μη τεκμηριωμένος",
        "right": "Καθαρός, τεκμηριωμένος"
      },
      {
        "label": "Σχεδιασμός",
        "left": "Προσαρμοσμένος στο τέλος",
        "right": "Ενσωματωμένος από την πρώτη μέρα"
      },
      {
        "label": "Μετά την κυκλοφορία",
        "left": "Εξαφανίζονται",
        "right": "Παραμένουμε δίπλα σας"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Μια ήρεμη, προβλέψιμη διαδρομή προς την κυκλοφορία",
    "steps": [
      {
        "title": "Ανακάλυψη",
        "body": "Προσδιορίζουμε τι να κατασκευάσουμε, για ποιους και γιατί έχει σημασία — γρήγορα."
      },
      {
        "title": "Σχέδιο",
        "body": "Πεδίο εφαρμογής, κατεύθυνση σχεδίασης, χρονοδιάγραμμα και ένας σταθερός προϋπολογισμός που εγκρίνετε."
      },
      {
        "title": "Κατασκευή σε sprints",
        "body": "Λειτουργίες εργασίας κάθε εβδομάδα, με την ανατροφοδότησή σας να κατευθύνει την κάθε μία."
      },
      {
        "title": "Εκκίνηση & υποστήριξη",
        "body": "Το κυκλοφορούμε, παρακολουθούμε την προσγείωσή του και συνεχίζουμε να το βελτιώνουμε μαζί σας."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Κατασκευή της εφαρμογής σας — απαντήσεις",
    "faqs": [
      {
        "q": "Έχω μια ιδέα αλλά όχι τεχνικό υπόβαθρο. Μπορείτε να βοηθήσετε ακόμα;",
        "a": "Ναι — οι περισσότεροι πελάτες μας δεν είναι τεχνικά καταρτισμένοι. Μεταφράζουμε την ιδέα σας σε ένα σαφές σχέδιο και χειριζόμαστε κάθε τεχνική απόφαση, εξηγώντας τα πράγματα με απλή γλώσσα."
      },
      {
        "q": "Εφαρμογή web, εφαρμογή κινητού, ή και τα δύο;",
        "a": "Όλα τα παραπάνω. Κατασκευάζουμε responsive web εφαρμογές, εφαρμογές κινητού και την τεχνολογία στο παρασκήνιο, και θα σας συμβουλέψουμε για το τι έχει νόημα για τους στόχους και τον προϋπολογισμό σας."
      },
      {
        "q": "Πώς αποφεύγετε να εκτοξευθεί ο προϋπολογισμός;",
        "a": "Καθορίζουμε το εύρος και την τιμή του σχεδίου πριν την κατασκευή. Το εγκρίνετε, και κατασκευάζουμε με βάση αυτό σε διαδοχικά στάδια — ώστε να μην υπάρχουν εκπλήξεις στη μέση του έργου."
      },
      {
        "q": "Θα μου ανήκει ο κώδικας;",
        "a": "Πλήρως. Παίρνετε καθαρό, τεκμηριωμένο κώδικα και πλήρη πρόσβαση. Χωρίς δεσμεύσεις, χωρίς να κρατάμε όμηρο το έργο σας."
      },
      {
        "q": "Τι συμβαίνει μετά την κυκλοφορία;",
        "a": "Δεν εξαφανιζόμαστε. Παρακολουθούμε, υποστηρίζουμε και συνεχίζουμε να βελτιώνουμε την εφαρμογή καθώς η επιχείρησή σας αναπτύσσεται — για όσο διάστημα μας θέλετε δίπλα σας."
      }
    ],
    "ctaTitle": "Ας το κατασκευάσουμε σωστά — την πρώτη φορά.",
    "ctaBody": "Πείτε μας για την ιδέα της εφαρμογής σας. Θα την μετατρέψουμε σε ένα σαφές σχέδιο με ένα πραγματικό πρόγραμμα, χρονοδιάγραμμα και προϋπολογισμό."
  },
  {
    "slug": "custom-portal-not-a-builder",
    "eyebrow": "// your_portal",
    "title": "Μια πύλη φτιαγμένη με τον τρόπο σας — [[όχι από πρότυπο.]]",
    "subtitle": "Οι κατασκευαστές ιστοσελίδων και τα πρότυπα πυλών αναγκάζουν την επιχείρησή σας στα δικά τους κουτιά. Φτιάχνουμε πύλες πελατών, συνεργατών και εσωτερικές πύλες ακριβώς σύμφωνα με το όραμά σας — κάθε ροή, άδεια και pixel.",
    "metaTitle": "Ανάπτυξη Προσαρμοσμένης Πύλης – Όχι Κατασκευαστής Ιστοσελίδων | DevCore",
    "metaDescription": "Σταματήστε να αναγκάζετε την επιχείρησή σας σε ένα πρότυπο. Η DevCore κατασκευάζει πύλες πελατών, συνεργατών και εσωτερικές πύλες ακριβώς στις προδιαγραφές σας — τις ροές σας, την επωνυμία σας, τους κανόνες σας.",
    "stats": [
      {
        "value": "0",
        "label": "περιορισμοί προτύπων"
      },
      {
        "value": "100%",
        "label": "η επωνυμία & οι ροές σας"
      },
      {
        "value": "∞",
        "label": "τρόποι ανάπτυξης"
      }
    ],
    "problemKicker": "// the_box",
    "problemTitle": "Οι κατασκευαστές σας δίνουν ένα κουτί. Η επιχείρησή σας δεν χωράει σε αυτό.",
    "problemBody": "Οι κατασκευαστές drag-and-drop και τα πρότυπα πυλών φαίνονται γρήγοροι — μέχρι να χτυπήσετε στον τοίχο. Η ροή σύνδεσης που χρειάζεστε δεν είναι δυνατή. Οι άδειες δεν ταιριάζουν με τον οργανισμό σας. Η επωνυμία φτάνει μόνο μέχρι ένα σημείο. Καταλήγετε να πληρώνετε μηνιαίως για κάτι που ακόμα δεν είναι σωστό.",
    "problemPoints": [
      "Άκαμπτα πρότυπα που συγκρούονται με τις πραγματικές ροές εργασίας σας",
      "Μοντέλα δικαιωμάτων που δεν ταιριάζουν με τον τρόπο που λειτουργούν οι ομάδες σας",
      "Branding που σταματάει σε ένα λογότυπο και ένα χρώμα",
      "Ενσωματώσεις μπλοκαρισμένες αν δεν αναβαθμίσετε — ξανά",
      "Μηνιαίες χρεώσεις για μια πύλη που είναι ακόμα «σχεδόν» σωστή"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Μια πύλη σχεδιασμένη εξ ολοκλήρου γύρω από εσάς",
    "pillars": [
      {
        "icon": "Layout",
        "title": "Ακριβώς το όραμά σας",
        "body": "Κάθε οθόνη, ροή και αλληλεπίδραση κατασκευασμένη στις προδιαγραφές σας — όχι συναρμολογημένη από όποια μπλοκ τυχαίνει να προσφέρει ένας κατασκευαστής."
      },
      {
        "icon": "ShieldCheck",
        "title": "Ρόλοι & δικαιώματα που ταιριάζουν",
        "body": "Λεπτομερής πρόσβαση για πελάτες, συνεργάτες, ομάδες και διαχειριστές — μοντελοποιημένη στον πραγματικό σας οργανισμό, όχι σε μια γενική προρύθμιση."
      },
      {
        "icon": "Boxes",
        "title": "Συνδεδεμένη με τα πάντα",
        "body": "Το CRM σας, οι χρεώσεις, η υποστήριξη, το Data Warehouse — η πύλη συνδέεται με τα συστήματα που ήδη χρησιμοποιείτε, χωρίς τεχνητούς περιορισμούς."
      },
      {
        "icon": "Sparkles",
        "title": "Branding μέχρι το pixel",
        "body": "Είναι αναμφισβήτητα δικό σας στην εμφάνιση και την αίσθηση — μια εμπειρία προϊόντος υψηλής ποιότητας, όχι ένα αναγνωρίσιμο πρότυπο."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Κατασκευαστής ιστοσελίδων vs. μια προσαρμοσμένη πύλη",
    "compareLeftLabel": "Κατασκευαστής / πρότυπο",
    "compareRightLabel": "Η προσαρμοσμένη πύλη σας",
    "compareRows": [
      {
        "label": "Ροές",
        "left": "Ό,τι χωράει στα μπλοκ",
        "right": "Ακριβώς οι προδιαγραφές σας"
      },
      {
        "label": "Δικαιώματα",
        "left": "Βασικές προεπιλογές",
        "right": "Μοντελοποιημένα στον οργανισμό σας"
      },
      {
        "label": "Branding",
        "left": "Λογότυπο + χρώματα",
        "right": "Pixel-perfect, δικό σας"
      },
      {
        "label": "Ενσωματώσεις",
        "left": "Περιορισμένες, επί πληρωμή",
        "right": "Ό,τι χρησιμοποιείτε"
      },
      {
        "label": "Τιμολόγηση",
        "left": "Μηνιαία, για πάντα",
        "right": "Το κατέχετε εξ ολοκλήρου"
      },
      {
        "label": "Ανάπτυξη",
        "left": "Φτάνετε στο ταβάνι",
        "right": "Χωρίς ταβάνι"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Από το «σχεδόν σωστό» στο ακριβώς σωστό",
    "steps": [
      {
        "title": "Ορίστε το όραμα",
        "body": "Χαρτογραφούμε τους χρήστες, τις ροές και την εμπειρία που θέλετε να έχουν."
      },
      {
        "title": "Σχεδιάστε το σχέδιο",
        "body": "Οθόνες, ρόλοι, ενσωματώσεις και εύρος — συμφωνημένα πριν κατασκευάσουμε."
      },
      {
        "title": "Κατασκευή σε sprints",
        "body": "Μια λειτουργική πύλη σε εβδομάδες, βελτιωμένη με την ανατροφοδότησή σας σε κάθε βήμα."
      },
      {
        "title": "Εκκίνηση & εξέλιξη",
        "body": "Βγείτε στον αέρα, και μετά αναπτύξτε την — νέα modules και ροές όποτε τα χρειαστεί η επιχείρησή σας."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Προσαρμοσμένες πύλες — απαντήσεις",
    "faqs": [
      {
        "q": "Τι είδους πύλες κατασκευάζετε;",
        "a": "Πύλες πελατών, πύλες συνεργατών και μεταπωλητών, πίνακες ελέγχου πελατών (client dashboards), εσωτερικές πύλες ομάδων, περιοχές μελών — οτιδήποτε όπου οι άνθρωποι συνδέονται για να κάνουν κάτι."
      },
      {
        "q": "Μπορεί να συνδεθεί με ταLυπάρχοντα συστήματά μας;",
        "a": "Ναι. Ενσωματώνουμε με το CRM, τις χρεώσεις, την υποστήριξη, τον πάροχο ταυτότητας και τις πηγές δεδομένων σας, ώστε η πύλη να είναι μέρος της στοίβας σας, όχι ένα απομονωμένο νησί."
      },
      {
        "q": "Πώς διαφέρει αυτό από έναν κατασκευαστή ιστοσελίδων;",
        "a": "Ένας κατασκευαστής σας περιορίζει στα μπλοκ και τους κανόνες του. Εμείς χτίζουμε ακριβώς σύμφωνα με τις απαιτήσεις σας — προσαρμοσμένες ροές, πραγματικά μοντέλα δικαιωμάτων και απεριόριστες ενσωματώσεις — και εσείς κατέχετε το αποτέλεσμα."
      },
      {
        "q": "Μπορούμε να προσθέσουμε περισσότερες λειτουργίες αργότερα;",
        "a": "Πάντα. Επειδή είναι προσαρμοσμένη και δική σας, μπορούν να προστεθούν νέα modules, τύποι χρηστών και ροές εργασίας όποτε τα χρειαστεί η επιχείρησή σας."
      },
      {
        "q": "Πόσο ασφαλές είναι;",
        "a": "Η ασφάλεια είναι ενσωματωμένη από την αρχή — ασφαλής σύνδεση, δικαιώματα πρόσβασης ανά ρόλο και προστασία δεδομένων, όχι μια εκ των υστέρων προσθήκη σε ένα πρότυπο."
      }
    ],
    "ctaTitle": "Φτιάξτε την πύλη που πραγματικά φανταστήκατε.",
    "ctaBody": "Περιγράψτε την πύλη στο μυαλό σας. Εμείς θα την μετατρέψουμε σε σχέδιο και θα την φτιάξουμε ακριβώς έτσι."
  },
  {
    "slug": "tools-that-dont-exist-yet",
    "eyebrow": "// build_the_unbuilt",
    "title": "Φτιάξτε το εργαλείο [[που δεν υπάρχει ακόμα.]]",
    "subtitle": "Μερικές φορές το τέλειο εργαλείο απλά δεν είναι στην αγορά — ή αυτά που είναι, κάνουν πάρα πολλά, ή πάρα λίγα. Κατασκευάζουμε το ακριβές εργαλείο που χρειάζεται η επιχείρησή σας, ούτε περισσότερο ούτε λιγότερο.",
    "metaTitle": "Δημιουργήστε προσαρμοσμένα εργαλεία που δεν υπάρχουν στην αγορά | DevCore",
    "metaDescription": "Δεν μπορείτε να βρείτε το σωστό εργαλείο — ή έχετε κολλήσει με φουσκωμένο λογισμικό που σχεδόν δεν χρησιμοποιείτε; Η DevCore κατασκευάζει το ακριβές προσαρμοσμένο εργαλείο που χρειάζεται η επιχείρησή σας, φτιαγμένο για να ταιριάζει και να σας ανήκει.",
    "stats": [
      {
        "value": "1",
        "label": "εργαλείο φτιαγμένο για να προσαρμόζεται"
      },
      {
        "value": "0",
        "label": "περιττό που δεν χρειάζεστε"
      },
      {
        "value": "100%",
        "label": "φτιαγμένο για την ροή εργασιών σας"
      }
    ],
    "problemKicker": "// the_gap",
    "problemTitle": "Το σωστό εργαλείο είτε δεν υπάρχει — είτε κάνει πάρα πολλά",
    "problemBody": "Έχετε ψάξει. Είτε τίποτα στην αγορά δεν λύνει το συγκεκριμένο πρόβλημά σας, είτε όλα όσα το κάνουν έρχονται με πρόσθετα κόστη, χαρακτηριστικά και τιμολόγηση που δεν θα χρειαστείτε ποτέ. Έτσι συμβιβάζεστε, και η ομάδα σας το πληρώνει σε χαμένο χρόνο κάθε μέρα.",
    "problemPoints": [
      "Κανένα προϊόν στην αγορά δεν κάνει το ένα πράγμα που πραγματικά χρειάζεστε",
      "Οι πιο κοντινές επιλογές είναι φουσκωμένες και υπερτιμημένες",
      "Χειρωνακτική, επαναλαμβανόμενη εργασία για την οποία κανείς δεν έχει χρόνο",
      "Ένα συνονθύλευμα από υπολογιστικά φύλλα και μισο-λειτουργικές πρόχειρες λύσεις",
      "Ώρες χάνονται κάθε εβδομάδα σε ένα πρόβλημα που θα έπρεπε να λύσει το λογισμικό"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Το ακριβές εργαλείο — τίποτα περισσότερο, τίποτα λιγότερο",
    "pillars": [
      {
        "icon": "Target",
        "title": "Φτιαγμένο για να ταιριάζει",
        "body": "Κατασκευασμένο γύρω από το ένα πρόβλημα που χρειάζεστε να επιλυθεί, με τον τρόπο που η ομάδα σας λειτουργεί πραγματικά — όχι ένας μέσος όρος των αναγκών όλων των άλλων."
      },
      {
        "icon": "Feather",
        "title": "Μηδενικό περιττό",
        "body": "Χωρίς χαρακτηριστικά που δεν θα χρησιμοποιήσετε ποτέ, χωρίς πρόσθετο κόστος που πληρώνετε και αγνοείτε. Λιτό, εστιασμένο και γρήγορο."
      },
      {
        "icon": "Zap",
        "title": "Αυτοματοποιεί την ρουτίνα",
        "body": "Η επαναλαμβανόμενη, χειρωνακτική εργασία που σας τρώει την εβδομάδα — αναλαμβάνεται. Η ομάδα σας κερδίζει πίσω τις ώρες."
      },
      {
        "icon": "Layers",
        "title": "Αναπτύσσεται κατ' απαίτηση",
        "body": "Ξεκινήστε με το βασικό εργαλείο, και στη συνέχεια προσθέστε ακριβώς τις δυνατότητες που χρειάζεστε, όταν τις χρειάζεστε."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Επιβολή ενός εργαλείου της αγοράς vs. κατασκευή του δικού σας",
    "compareLeftLabel": "Το πιο κοντινό εργαλείο της αγοράς",
    "compareRightLabel": "Το προσαρμοσμένο σας εργαλείο",
    "compareRows": [
      {
        "label": "Εφαρμογή",
        "left": "Σχεδόν, ποτέ ακριβής",
        "right": "Κατασκευασμένο για τη δουλειά"
      },
      {
        "label": "Χαρακτηριστικά",
        "left": "Φουσκωμένα ή λείπουν",
        "right": "Ακριβώς τα σωστά"
      },
      {
        "label": "Γενικά έξοδα",
        "left": "Πληρώστε για τα αχρησιμοποίητα",
        "right": "Κανένα"
      },
      {
        "label": "Ροή εργασιών",
        "left": "Εσείς προσαρμόζεστε",
        "right": "Προσαρμόζεται σε εσάς"
      },
      {
        "label": "Κόστος",
        "left": "Συνδρομή για πάντα",
        "right": "Σας ανήκει"
      },
      {
        "label": "Μέλλον",
        "left": "Περιμένετε τον οδικό τους χάρτη",
        "right": "Προσθέστε ό,τι χρειάζεστε"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Από το «αυτό θα έπρεπε να υπάρχει» στο να υπάρχει",
    "steps": [
      {
        "title": "Καρφώστε το πρόβλημα",
        "body": "Γινόμαστε απόλυτα σαφείς για το ένα πράγμα που το εργαλείο πρέπει να κάνει άψογα."
      },
      {
        "title": "Σχεδιάστε το",
        "body": "Πεδίο εφαρμογής, σχεδιασμός και σταθερός προϋπολογισμός για ένα λιτό, εστιασμένο εργαλείο."
      },
      {
        "title": "Κατασκευάστε τον πυρήνα",
        "body": "Μια λειτουργική έκδοση σε εβδομάδες — το βασικό εργαλείο, που κάνει τη δουλειά του."
      },
      {
        "title": "Οξύνετε & επεκτείνετε",
        "body": "Εκλεπτύνετέ το σε πραγματική χρήση, και στη συνέχεια προσθέστε δυνατότητες μόνο όταν τις χρειάζεστε."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Η κατασκευή του ανυπάρχοντος — απαντήθηκε",
    "faqs": [
      {
        "q": "Τι γίνεται αν δεν είμαι σίγουρος ακριβώς τι πρέπει να είναι το εργαλείο;",
        "a": "Είναι φυσιολογικό — και εκεί βοηθάμε περισσότερο. Ξεκινάμε από το πρόβλημα και διαμορφώνουμε το σωστό εργαλείο μαζί σας, οπότε δεν χρειάζεστε μια ολοκληρωμένη προδιαγραφή για να ξεκινήσετε."
      },
      {
        "q": "Αξίζει να φτιάξω κάτι τόσο συγκεκριμένο;",
        "a": "Αν το πρόβλημα σας κοστίζει πραγματικό χρόνο ή χρήμα κάθε εβδομάδα, σχεδόν πάντα. Ένα εστιασμένο εργαλείο που ταιριάζει απόλυτα αποπληρώνεται πολύ γρηγορότερα από ό,τι περιμένουν οι άνθρωποι."
      },
      {
        "q": "Μπορεί να χρησιμοποιήσει AI;",
        "a": "Ναι. Όταν πραγματικά βοηθά — αυτοματοποιώντας αποφάσεις, επεξεργαζόμενο κείμενο ή δεδομένα, βοηθώντας την ομάδα σας — ενσωματώνουμε AI, με λογικές διασφαλίσεις. Όταν δεν βοηθά, το κρατάμε απλό."
      },
      {
        "q": "Πόσο μικρό μπορεί να είναι ένα έργο;",
        "a": "Το μικρό είναι αποδεκτό. Ένα ενιαίο, αιχμηρό εργαλείο που αφαιρεί ένα επίπονο σημείο συμφόρησης είναι ένα από τα έργα με τη μεγαλύτερη απόδοση επένδυσης που κατασκευάζουμε."
      },
      {
        "q": "Θα ανήκει σε μένα;",
        "a": "Ναι — πλήρως. Καθαρός κώδικας, πλήρης πρόσβαση, χωρίς περιορισμούς. Είναι το εργαλείο σας και το περιουσιακό σας στοιχείο."
      }
    ],
    "ctaTitle": "Αν πρέπει να υπάρχει, ας το φτιάξουμε.",
    "ctaBody": "Περιγράψτε το εργαλείο που θα θέλατε να έχετε. Θα σας πούμε ακριβώς πώς θα το κατασκευάζαμε — και θα σας ανήκει."
  },
  {
    "slug": "combine-your-tools-into-one-suite",
    "eyebrow": "// one_suite",
    "title": "Πολλά διασκορπισμένα εργαλεία. [[Μία προσαρμοσμένη σουίτα.]]",
    "subtitle": "Η ομάδα σας πηδάει ανάμεσα σε δώδεκα εφαρμογές, αντιγράφει δεδομένα με το χέρι και πληρώνει για κάθε μία ξεχωριστά. Ενοποιούμε τα μικρά εργαλεία που χρησιμοποιείτε πραγματικά σε μια ενιαία, προσαρμοσμένη σουίτα — μία σύνδεση, μία πηγή αλήθειας, χτισμένη γύρω από τη ροή εργασίας σας.",
    "metaTitle": "Ενοποιήστε Πολλά Εργαλεία σε Μία Προσαρμοσμένη Σουίτα | DevCore",
    "metaDescription": "Σταματήστε να χειρίζεστε δώδεκα αποσυνδεδεμένες εφαρμογές. Η DevCore ενοποιεί τα μικρά σας εργαλεία σε μία προσαρμοσμένη σουίτα — ενιαία σύνδεση, κοινά δεδομένα, τέλος το copy-paste ή οι συσσωρευμένες συνδρομές.",
    "stats": [
      {
        "value": "1",
        "label": "σουίτα αντί για δώδεκα εφαρμογές"
      },
      {
        "value": "0",
        "label": "αντιγραφή-επικόλληση μεταξύ εργαλείων"
      },
      {
        "value": "100%",
        "label": "συνδεδεμένα, κοινόχρηστα δεδομένα"
      }
    ],
    "problemKicker": "// the_sprawl",
    "problemTitle": "Δώδεκα εφαρμογές που δεν επικοινωνούν μεταξύ τους",
    "problemBody": "Κάθε πρόβλημα απέκτησε το δικό του εργαλείο, και τώρα η ομάδα σας ζει σε χάος καρτελών. Τα δεδομένα διπλασιάζονται σε όλες τις εφαρμογές, τίποτα δεν μένει συγχρονισμένο, και πληρώνετε μια ξεχωριστή συνδρομή για το καθένα. Τα εργαλεία υποτίθεται ότι θα εξοικονομούσαν χρόνο — μαζί τον σπαταλούν αθόρυβα.",
    "problemPoints": [
      "Τα ίδια δεδομένα εισάγονται ξανά σε τρεις ή τέσσερις διαφορετικές εφαρμογές",
      "Ατελείωτη εναλλαγή καρτελών και χαμένο πλαίσιο καθ’ όλη τη διάρκεια της ημέρας",
      "Εργαλεία που δεν συγχρονίζονται, οπότε οι αριθμοί ποτέ δεν ταιριάζουν ακριβώς",
      "Ένας σωρός από ξεχωριστές συνδρομές που συσσωρεύονται κάθε μήνα",
      "Κανένα ενιαίο μέρος για να δείτε τι συμβαίνει πραγματικά"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Όλα όσα χρειάζεται η ομάδα σας, σε ένα μέρος",
    "pillars": [
      {
        "icon": "Boxes",
        "title": "Τα εργαλεία σας, ενοποιημένα",
        "body": "Οι λίγες μικρές εφαρμογές στις οποίες βασίζεστε, ανακατασκευασμένες ως συνδεδεμένες μονάδες σε μία σουίτα — σχεδιασμένες να λειτουργούν μαζί αντί να συγκρούονται."
      },
      {
        "icon": "Database",
        "title": "Μία πηγή αλήθειας",
        "body": "Εισάγετε δεδομένα μία φορά και είναι παντού εκεί που χρειάζεται. Χωρίς διπλότυπα, χωρίς εξαγωγές, χωρίς αντιγραφή-επικόλληση — κάθε ενότητα μοιράζεται τα ίδια ζωντανά δεδομένα."
      },
      {
        "icon": "Layers",
        "title": "Μία σύνδεση, μία εμπειρία",
        "body": "Μία ενιαία, συνεπής διεπαφή και ένα σύνολο δικαιωμάτων για τα πάντα — η ομάδα σας το μαθαίνει μία φορά και σταματά να ψάχνει στις εφαρμογές."
      },
      {
        "icon": "Zap",
        "title": "Λιγότερο κόστος, λιγότερα γενικά έξοδα",
        "body": "Αντικαταστήστε ένα σωρό συνδρομές και την εργασία σύνδεσης μεταξύ τους με ένα εργαλείο που σας ανήκει — χαμηλότερο κόστος λειτουργίας και πολύ λιγότερα για συντήρηση."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Ένα συνονθύλευμα εφαρμογών έναντι μίας προσαρμοσμένης σουίτας",
    "compareLeftLabel": "Διασκορπισμένα εργαλεία",
    "compareRightLabel": "Η προσαρμοσμένη σουίτα σας",
    "compareRows": [
      {
        "label": "Δεδομένα",
        "left": "Διπλασιασμένα παντού",
        "right": "Μία κοινόχρηστη πηγή"
      },
      {
        "label": "Ροή εργασία",
        "left": "Συνεχής εναλλαγή καρτελών",
        "right": "Μία συνδεδεμένη ροή"
      },
      {
        "label": "Συνδέσεις",
        "left": "Μία ανά εφαρμογή",
        "right": "Ενιαία σύνδεση"
      },
      {
        "label": "Κόστος",
        "left": "Πολλές συνδρομές",
        "right": "Μία ιδιόκτητη σουίτα"
      },
      {
        "label": "Ενσωματώσεις",
        "left": "Εύθραυστες, συχνά χαλούν",
        "right": "Ενσωματωμένες, εγγενείς"
      },
      {
        "label": "Επισκόπηση",
        "left": "Διασκορπισμένη, μερική",
        "right": "Μία καθαρή εικόνα"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Από τη διασπορά εργαλείων σε μία προσαρμοσμένη σουίτα",
    "steps": [
      {
        "title": "Ελέγξτε τη στοίβα σας",
        "body": "Χαρτογραφούμε κάθε εργαλείο που χρησιμοποιεί η ομάδα σας και πού κυκλοφορούν πραγματικά τα δεδομένα μεταξύ τους."
      },
      {
        "title": "Σχεδιάστε τη σουίτα",
        "body": "Ένα σχέδιο των ενοποιημένων μονάδων, του κοινού μοντέλου δεδομένων και μιας καθαρής διεπαφής — συμφωνημένο πριν την κατασκευή."
      },
      {
        "title": "Κατασκευή & Μεταφορά",
        "body": "Παραδίδουμε τη σουίτα σε sprints και μεταφέρουμε τα δεδομένα σας από τα παλιά εργαλεία με καθαρό τρόπο."
      },
      {
        "title": "Μετάβαση & Επέκταση",
        "body": "Η ομάδα σας μεταφέρεται σε ένα εργαλείο, και προσθέτουμε μονάδες καθώς προκύπτουν νέες ανάγκες."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Μία σουίτα — απαντήσεις",
    "faqs": [
      {
        "q": "Μπορείτε πραγματικά να αντικαταστήσετε όλα τα ξεχωριστά μας εργαλεία;",
        "a": "Συνήθως αυτά που είναι σημαντικά, ναι. Εστιάζουμε στα εργαλεία που χρησιμοποιεί η ομάδα σας καθημερινά και στα δεδομένα που ρέουν μεταξύ τους, ανακατασκευάζοντάς τα ως συνδεδεμένες ενότητες σε μία σουίτα. Οτιδήποτε καλύτερα να παραμείνει σε ένα εξειδικευμένο εργαλείο, το ενσωματώνουμε αντ' αυτού."
      },
      {
        "q": "Τι γίνεται με τα εργαλεία που θέλουμε να κρατήσουμε;",
        "a": "Κανένα πρόβλημα. Η σουίτα συνδέεται με τα εξωτερικά εργαλεία που θέλετε να κρατήσετε — email, λογιστική, πληρωμές κ.ο.κ. — έτσι ώστε όλα να καταλήγουν σε ένα μέρος."
      },
      {
        "q": "Μπορείτε να μεταφέρετε τα υπάρχοντα δεδομένα μας;",
        "a": "Ναι. Η καθαρή μεταφορά από τις τρέχουσες εφαρμογές και τα υπολογιστικά φύλλα σας είναι μέρος του έργου, οπότε τίποτα δεν μένει πίσω στην αλλαγή."
      },
      {
        "q": "Δεν είναι ένα μεγάλο εργαλείο πιο επικίνδυνο σε σχέση με πολλά μικρά;",
        "a": "Είναι το αντίθετο από ένα εύθραυστο συνονθύλευμα. Μία καλά κατασκευασμένη, ιδιόκτητη σουίτα σημαίνει λιγότερες χαλασμένες ενσωματώσεις, λιγότερους προμηθευτές και ένα μέρος για ασφάλεια και συντήρηση — πολύ πιο στιβαρή από δώδεκα εφαρμογές που έχουν κολληθεί με μονωτική ταινία."
      },
      {
        "q": "Μπορεί να αναπτυχθεί καθώς προσθέτουμε νέες ανάγκες;",
        "a": "Πάντα. Νέες μονάδες και ροές εργασίας προστίθενται στην ίδια σουίτα όταν τις χρειάζεστε — χωρίς νέες συνδρομές, χωρίς φρέσκους πονοκεφάλους ενσωμάτωσης."
      }
    ],
    "ctaTitle": "Μετατρέψτε τη διασπορά των εργαλείων σας σε μία σουίτα.",
    "ctaBody": "Πείτε μας ποιες εφαρμογές χρησιμοποιεί η ομάδα σας καθημερινά. Θα σας δείξουμε πώς ταιριάζουν σε μια ενιαία σουίτα χτισμένη γύρω από εσάς."
  },
  {
    "slug": "why-not-vibecode-it-yourself",
    "eyebrow": "// vibecoding",
    "title": "Γιατί να μην το [[φτιάξετε μόνοι σας με vibecoding;]]",
    "subtitle": "Η ΤΝ κάνει την ανάπτυξη να φαίνεται αβίαστη — μέχρι το demo να πρέπει να γίνει πραγματικό προϊόν. Το vibecoding είναι εξαιρετικό για πρωτότυπα και επικίνδυνο για παραγωγή. Δείτε πού σπάει και γιατί μια έμπειρη ομάδα μετατρέπει την ιδέα σας σε λογισμικό που μπορείτε πραγματικά να εμπιστευτείτε.",
    "metaTitle": "Γιατί να μην το φτιάξετε μόνοι σας με vibecoding; Η ειλικρινής απάντηση | DevCore",
    "metaDescription": "Τα εργαλεία ΤΝ φτιάχνουν ένα πρωτότυπο σε ένα απόγευμα — αλλά η παραγωγή είναι άλλο παιχνίδι. Δείτε πού σπάει το vibecoding (ασφάλεια, κλιμάκωση, συντήρηση) και πότε χρειάζεστε επαγγελματίες.",
    "stats": [
      { "value": "1 μέρα", "label": "για demo — μήνες για πραγματικό προϊόν" },
      { "value": "80%", "label": "της δουλειάς είναι το αόρατο 80%" },
      { "value": "100%", "label": "της ευθύνης μένει σε εσάς" }
    ],
    "problemKicker": "// η_παγίδα",
    "problemTitle": "Το demo δουλεύει. Αυτή ακριβώς είναι η παγίδα.",
    "problemBody": "Το vibecoding σας δίνει μια λειτουργική οθόνη εκπληκτικά γρήγορα — και αυτή η πρώτη νίκη κρύβει όλα όσα υπάρχουν από κάτω. Ασφαλής σύνδεση, ακεραιότητα δεδομένων, ακραίες περιπτώσεις, ασφάλεια, απόδοση, πληρωμές, συμμόρφωση: τίποτα από αυτά δεν εμφανίζεται σε ένα demo, και όλα εμφανίζονται τη στιγμή που έρχονται πραγματικοί χρήστες (και επιτιθέμενοι). Το κενό ανάμεσα στο «τρέχει» και στο «θα στοιχημάτιζα την επιχείρησή μου» είναι εκεί όπου οι περισσότερες αυτοσχέδιες εφαρμογές καταρρέουν σιωπηλά.",
    "problemPoints": [
      "Κενά ασφαλείας που δεν βλέπετε — εκτεθειμένα δεδομένα, ελλιπείς κανόνες πρόσβασης, διαρρεύσαντα κλειδιά",
      "Κώδικας που δουλεύει μία φορά αλλά κανείς — ούτε εσείς — δεν μπορεί να αλλάξει με ασφάλεια αργότερα",
      "Ακραίες περιπτώσεις, σφάλματα και παράξενες εισόδους που κρασάρουν την πραγματική χρήση",
      "Καθόλου tests, backups ή monitoring — μέχρι κάτι να σπάσει στην παραγωγή",
      "Κάθε ώρα debugging της ΤΝ είναι μια ώρα που δεν διοικείτε την επιχείρησή σας"
    ],
    "pillarsKicker": "// η_πραγματικότητα",
    "pillarsTitle": "Τι δεν δείχνει στην οθόνη το vibecoding",
    "pillars": [
      { "icon": "ShieldCheck", "title": "Ασφάλεια & ακεραιότητα δεδομένων", "body": "Ασφαλής σύνδεση, σαφή δικαιώματα πρόσβασης, ελεγμένες είσοδοι και ασφαλώς προστατευμένοι κωδικοί & κλειδιά — αυτά που η ΤΝ ευχαρίστως παραλείπει και οι επιτιθέμενοι ευχαρίστως βρίσκουν. Τα χτίζουμε από την πρώτη γραμμή." },
      { "icon": "TrendingUp", "title": "Χτισμένο για κλιμάκωση", "body": "Ένα πρωτότυπο για 5 χρήστες μπορεί να καταρρεύσει στους 500. Σχεδιάζουμε δεδομένα, queries και υποδομή ώστε η ανάπτυξη να μην είναι γεγονός — ούτε επανασχεδίαση." },
      { "icon": "Code2", "title": "Συντηρήσιμα θεμέλια", "body": "Καθαρός, τεκμηριωμένος, δοκιμασμένος κώδικας που ένας άνθρωπος μπορεί να κατανοήσει — ώστε η εφαρμογή να εξελίσσεται αντί να γίνεται ένα μαύρο κουτί που φοβάστε να αγγίξετε." },
      { "icon": "Eye", "title": "Κρίση, όχι μόνο output", "body": "Η ΤΝ παράγει κώδικα· δεν αναλαμβάνει το αποτέλεσμα. Οι έμπειροι μηχανικοί παίρνουν τις αποφάσεις που η ΤΝ δεν μπορεί — συμβιβασμούς, αρχιτεκτονική και ό,τι σας γλιτώνει μήνες αργότερα." }
    ],
    "compareKicker": "// συγκριση",
    "compareTitle": "Vibecoding μόνοι σας vs. ανάπτυξη με επαγγελματίες",
    "compareLeftLabel": "DIY vibecoding",
    "compareRightLabel": "Με τη DevCore",
    "compareRows": [
      { "label": "Ταχύτητα ως demo", "left": "Ώρες", "right": "Ώρες", "leftPositive": true },
      { "label": "Διαδικασία δημοσίευσης", "left": "Χειροκίνητη, εύθραυστη, σπάει κατά την ενημέρωση", "right": "Αυτοματοποιημένη, με ασφαλή επαναφορά" },
      { "label": "Hosting & υποδομή", "left": "Στην τύχη, χωρίς monitoring", "right": "Ρυθμισμένη, κλιμακούμενη, παρακολουθούμενη" },
      { "label": "Επιδόσεις", "left": "Επιβραδύνει με πραγματικά δεδομένα", "right": "Profiled, cached, βελτιστοποιημένη" },
      { "label": "Σφάλματα & ακραίες περιπτώσεις", "left": "Εμφανίζονται στην παραγωγή", "right": "Πιάνονται με tests πριν το launch" },
      { "label": "Ασφάλεια", "left": "Άγνωστη / ελπίδα", "right": "Σχεδιασμένη, ελεγμένη, θωρακισμένη" },
      { "label": "Συνδέσεις με άλλα προγράμματα", "left": "Εύθραυστα, πρόχειρα συναρμολογημένα", "right": "Στιβαρά και καθαρά τεκμηριωμένα" }
    ],
    "processKicker": "// πως_χτιζουμε",
    "processTitle": "Κρατήστε την ταχύτητα. Χάστε το ρίσκο.",
    "steps": [
      { "title": "Φέρτε το πρωτότυπό σας", "body": "Φτιάξατε ήδη κάτι με vibecoding; Τέλεια — είναι η ιδανική προδιαγραφή. Το μετατρέπουμε σε πραγματικό σχέδιο." },
      { "title": "Blueprint του πραγματικού", "body": "Εύρος, αρχιτεκτονική, ασφάλεια και σταθερός προϋπολογισμός — ό,τι πραγματικά απαιτεί η παραγωγή, χωρίς εικασίες." },
      { "title": "Σωστή ανάπτυξη", "body": "Έμπειροι μηχανικοί παραδίδουν λειτουργικό λογισμικό σε sprints, με tests, reviews και το αόρατο 80% τακτοποιημένο." },
      { "title": "Launch & ιδιοκτησία", "body": "Παίρνετε καθαρό κώδικα, πλήρη ιδιοκτησία και ένα εργαλείο που εμπιστεύεστε με πραγματικούς χρήστες — και πραγματικά χρήματα." }
    ],
    "faqKicker": "// ερωτησεις",
    "faqTitle": "Vibecoding vs. σωστή ανάπτυξη — απαντήσεις",
    "faqs": [
      { "q": "Δεν είναι αρκετά καλή πια η ΤΝ για να φτιάξει όλη την εφαρμογή μου;", "a": "Για πρωτότυπα και εσωτερικά πειράματα, συχνά ναι — και είναι πραγματικά ισχυρή. Για λογισμικό παραγωγής με πραγματικούς χρήστες, πληρωμές, δεδομένα και ασφάλεια, η ΤΝ είναι εργαλείο, όχι ομάδα. Γράφει κώδικα γρήγορα αλλά δεν αναλαμβάνει την αρχιτεκτονική, τους συμβιβασμούς ή τις συνέπειες. Εκεί μπαίνουμε εμείς." },
      { "q": "Έχω ήδη φτιάξει κάτι με vibecoding. Πάει χαμένο;", "a": "Καθόλου — είναι περιουσιακό στοιχείο. Ένα λειτουργικό πρωτότυπο είναι το πιο ξεκάθαρο brief: δείχνει ακριβώς τι θέλετε. Το χρησιμοποιούμε ως blueprint και το ξαναχτίζουμε σε στέρεα, ασφαλή, κλιμακώσιμη βάση — συχνά πολύ πιο γρήγορα, γιατί η σκέψη έχει ήδη γίνει." },
      { "q": "Γιατί να σας πληρώσω όταν η ΤΝ είναι τόσο φθηνή;", "a": "Δεν πληρώνετε για τη γραφή κώδικα — αυτό το έκανε φθηνό η ΤΝ. Πληρώνετε για κρίση: την ασφάλεια που δεν βλέπετε, την αρχιτεκτονική που δεν καταρρέει, τις αποφάσεις που αποτρέπουν ακριβές επανασχεδιάσεις. Το φθηνό κομμάτι δεν ήταν ποτέ το εμπόδιο." },
      { "q": "Χρησιμοποιείτε κι εσείς ΤΝ;", "a": "Φυσικά — θα ήμασταν πιο αργοί χωρίς αυτήν. Η διαφορά είναι ότι τη χρησιμοποιούμε υπό έμπειρη επίβλεψη, με reviews, tests και πρότυπα. Παίρνετε την ταχύτητα της ΤΝ με την ευθύνη ενός επαγγελματία, όχι ακατέργαστο output στην παραγωγή." },
      { "q": "Πώς ξέρω πότε να σταματήσω το DIY και να σας καλέσω;", "a": "Όταν εμπλέκονται πραγματικοί χρήστες, πραγματικά χρήματα ή ευαίσθητα δεδομένα — ή όταν ξοδεύετε περισσότερο χρόνο παλεύοντας με τον κώδικά σας παρά χτίζοντας την επιχείρησή σας. Αν ένα bug μπορεί να σας κοστίσει πελάτες ή μια διαρροή να σας κοστίσει εμπιστοσύνη, είναι ώρα." }
    ],
    "ctaTitle": "Αγαπάτε την ταχύτητα; Κρατήστε την — χωρίς το ρίσκο.",
    "ctaBody": "Στείλτε μας το vibecoded πρωτότυπό σας ή απλώς την ιδέα. Θα σας δείξουμε τι χρειάζεται για να γίνει έτοιμο για παραγωγή — και θα το χτίσουμε για εσάς."
  },
  {
    "slug": "ai-built-into-your-software",
    "eyebrow": "// ai_inside",
    "title": "AI που κάνει πραγματική δουλειά — [[χτισμένη μέσα στο λογισμικό σας.]]",
    "subtitle": "Οι περισσότεροι κολλάνε ένα chatbot σε ένα έτοιμο προϊόν και το λένε AI. Εμείς σχεδιάζουμε τη νοημοσύνη στον πυρήνα αυτού που χτίζουμε — διαβάζει έγγραφα, απαντά σε χρήστες, εντοπίζει τάσεις και ταξινομεί το χάος, κάθε μέρα.",
    "metaTitle": "AI χτισμένη στο λογισμικό σας — όχι κολλημένη | DevCore",
    "metaDescription": "Σταματήστε να κολλάτε ένα chatbot σε ένα έτοιμο προϊόν. Η DevCore χτίζει AI στον πυρήνα του λογισμικού σας: ανάλυση PDF, copilots, αναλύσεις KPI, scraping και έξυπνη οργάνωση.",
    "stats": [
      { "value": "9", "label": "δυνατότητες AI σε παραγωγή" },
      { "value": "24/7", "label": "δουλειά αυτόματα" },
      { "value": "0", "label": "χειροκίνητο copy-paste" }
    ],
    "problemKicker": "// το_κόλπο",
    "problemTitle": "Ένα chatbot στη γωνία δεν είναι στρατηγική AI",
    "problemBody": "Το να κολλήσετε έναν γενικό βοηθό σε μια έτοιμη εφαρμογή φαίνεται μοντέρνο αλλά δεν αλλάζει τίποτα. Η ομάδα σας συνεχίζει να ξαναπληκτρολογεί δεδομένα από PDF, ψάχνει απαντήσεις, φτιάχνει αναφορές με το χέρι και πνίγεται σε αταξινόμητα στοιχεία. Η πραγματική AI αφαιρεί τη δουλειά — δεν περιμένει απλώς να τη ρωτήσουν.",
    "problemPoints": [
      "Ώρες χαμένες στην πληκτρολόγηση δεδομένων από PDF, τιμολόγια και συμβόλαια",
      "Χρήστες ψάχνουν μέσα σε έγγραφα αντί να παίρνουν απαντήσεις",
      "Αναφορές φτιαγμένες με το χέρι, πάντα μια εβδομάδα παρωχημένες",
      "Δεδομένα διασκορπισμένα σε web, άλλα προγράμματα και υπολογιστικά φύλλα",
      "Inbox και ουρές στοιβάζονται, τίποτα δεν ταξινομείται αυτόματα"
    ],
    "pillarsKicker": "// τι_χτίζουμε",
    "pillarsTitle": "Εννέα τρόποι που η AI κάνει πραγματική δουλειά στο προϊόν σας",
    "pillars": [
      {
        "icon": "FileText",
        "title": "Ανάλυση εγγράφων & PDF",
        "body": "Ρίξτε συμβόλαια, τιμολόγια ή αναφορές και πάρτε πίσω καθαρά, δομημένα δεδομένα — χωρίς χειροκίνητη πληκτρολόγηση, χωρίς copy-paste, χωρίς λάθη."
      },
      {
        "icon": "Sparkles",
        "title": "Ενσωματωμένο copilot & chatbot",
        "body": "Ένας βοηθός με επίγνωση πλαισίου μέσα στο προϊόν σας που απαντά σε ερωτήσεις, συντάσσει περιεχόμενο και εκτελεί πραγματικές ενέργειες για τους χρήστες σας."
      },
      {
        "icon": "Gauge",
        "title": "Αναλύσεις KPI & δεδομένων",
        "body": "Live dashboards που μετατρέπουν ακατέργαστους αριθμούς σε τάσεις, ειδοποιήσεις και αποφάσεις που η ομάδα σας μπορεί να εφαρμόσει αμέσως."
      },
      {
        "icon": "Database",
        "title": "Scraping & συλλογή δεδομένων",
        "body": "Αντλήστε δεδομένα από web, άλλα προγράμματα και αρχεία και οργανώστε τα σε μία καθαρή, αξιόπιστη πηγή που μπορείτε να εμπιστευτείτε."
      },
      {
        "icon": "Workflow",
        "title": "Έξυπνη οργάνωση",
        "body": "Αυτόματο tagging, δρομολόγηση και ταξινόμηση εισερχομένων ώστε να μη χάνεται τίποτα και η ομάδα σας να παραμένει συγκεντρωμένη."
      },
      {
        "icon": "Eye",
        "title": "Έξυπνη αναζήτηση & ανάκτηση",
        "body": "Σημασιολογική αναζήτηση σε κάθε έγγραφο, ticket και εγγραφή — η ομάδα σας βρίσκει τη σωστή απάντηση σε δευτερόλεπτα, χωρίς ακριβείς λέξεις-κλειδιά."
      },
      {
        "icon": "Feather",
        "title": "Σύνταξη & δημιουργία περιεχομένου",
        "body": "Αυτόματη σύνταξη email, απαντήσεων, περιλήψεων και αναφορών στο δικό σας ύφος, έτοιμα για έγκριση και αποστολή με ένα κλικ."
      },
      {
        "icon": "TrendingUp",
        "title": "Προβλέψεις & εντοπισμός ανωμαλιών",
        "body": "Προβλέψτε ζήτηση, αποχώρηση και κίνδυνο — και ειδοποιηθείτε τη στιγμή που ένας αριθμός ξεφεύγει από το σύνηθες."
      },
      {
        "icon": "Target",
        "title": "Αυτόματη διαλογή & δρομολόγηση",
        "body": "Διαβάζει εισερχόμενα αιτήματα, κατανοεί την πρόθεση και τα δρομολογεί ή τα κλιμακώνει αμέσως στο σωστό άτομο ή workflow."
      }
    ],
    "compareKicker": "// σύγκριση",
    "compareTitle": "Κολλημένη AI vs. AI στον πυρήνα",
    "compareLeftLabel": "Κολλημένο chatbot",
    "compareRightLabel": "AI στον πυρήνα",
    "compareRows": [
      { "label": "Ρόλος", "left": "Περιμένει να τη ρωτήσουν", "right": "Κάνει δουλειά αυτόματα" },
      { "label": "Έγγραφα", "left": "Ακόμα ξαναπληκτρολογείτε", "right": "Μετατρέπονται σε καθαρά δεδομένα" },
      { "label": "Απαντήσεις", "left": "Γενικές, εκτός πλαισίου", "right": "Βασισμένες στα δεδομένα σας" },
      { "label": "Reporting", "left": "Χειροκίνητο, πάντα αργά", "right": "Live και προληπτικό" },
      { "label": "Δεδομένα", "left": "Διασκορπισμένα παντού", "right": "Συλλεγμένα & κανονικοποιημένα" },
      { "label": "Αξία", "left": "Ένα demo feature", "right": "Καθημερινό πραγματικό αποτέλεσμα" }
    ],
    "processKicker": "// πώς_χτίζουμε",
    "processTitle": "Από το hype της AI σε AI που αποδίδει",
    "steps": [
      { "title": "Βρίσκουμε την πραγματική δουλειά", "body": "Χαρτογραφούμε πού χάνει ώρες η ομάδα σας — την πληκτρολόγηση, την αναζήτηση και την ταξινόμηση που η AI μπορεί πραγματικά να αφαιρέσει." },
      { "title": "Σχεδιάζουμε το blueprint", "body": "Ποιες δυνατότητες AI, πού βρίσκονται στο προϊόν σας και τις δικλείδες ασφαλείας που τις κρατούν ασφαλείς." },
      { "title": "Τις χτίζουμε μέσα", "body": "Ενσωματώνουμε τη νοημοσύνη στον πυρήνα του λογισμικού σας σε sprints — δοκιμασμένη, όχι gimmick." },
      { "title": "Μετράμε & βελτιώνουμε", "body": "Παρακολουθούμε τη δουλειά που εξοικονομεί και συνεχίζουμε να βελτιώνουμε την ακρίβεια, ώστε η αξία να αυξάνεται με τον χρόνο." }
    ],
    "faqKicker": "// ερωτήσεις",
    "faqTitle": "AI στο λογισμικό σας — απαντήσεις",
    "faqs": [
      { "q": "Είναι απλώς ένα ChatGPT wrapper;", "a": "Όχι. Ένα wrapper απαντά σε ερωτήσεις· εμείς χτίζουμε AI που δουλεύει — μετατρέπει έγγραφα σε δομημένα δεδομένα, παράγει live αναλύσεις, συλλέγει και κανονικοποιεί δεδομένα, αναζητά σε όλα, κάνει προβλέψεις, συντάσσει κείμενα και δρομολογεί στοιχεία αυτόματα. Το chatbot είναι μόνο μία από εννέα δυνατότητες, και ακόμα κι αυτό βασίζεται στα δικά σας δεδομένα." },
      { "q": "Είναι ασφαλή τα δεδομένα μας όταν προσθέτετε AI;", "a": "Ναι. Σχεδιάζουμε με αυστηρές δικλείδες ασφαλείας: περιορισμένη πρόσβαση, καμία εκπαίδευση στα ιδιωτικά σας δεδομένα, επικύρωση εισόδου και σαφή όρια στο τι μπορεί και δεν μπορεί να κάνει η AI. Η ασφάλεια είναι ενσωματωμένη από το blueprint, όχι προστιθέμενη αργότερα." },
      { "q": "Πόσο ακριβής είναι η ανάλυση εγγράφων και PDF με AI;", "a": "Πολύ ακριβής για δομημένα έγγραφα όπως τιμολόγια, συμβόλαια και αναφορές — και προσθέτουμε επικύρωση και ελέγχους human-in-the-loop όπου η ακρίβεια είναι κρίσιμη, για ταχύτητα χωρίς τυφλή εμπιστοσύνη." },
      { "q": "Μπορείτε να προσθέσετε AI σε λογισμικό που ήδη έχουμε;", "a": "Συχνά ναι. Μπορούμε να ενσωματώσουμε αυτές τις δυνατότητες σε υπάρχον προϊόν ή να τις χτίσουμε σε κάτι νέο. Ξεκινάμε από εκεί που η νοημοσύνη προσφέρει τη μεγαλύτερη αξία." },
      { "q": "Πόσο γρήγορα θα κάνει η AI πραγματική δουλειά;", "a": "Μια εστιασμένη πρώτη δυνατότητα είναι συνήθως live σε λίγες εβδομάδες. Παραδίδουμε σε βήματα, ώστε να βλέπετε πραγματικό αποτέλεσμα νωρίς αντί να περιμένετε μήνες για ένα μεγάλο launch." }
    ],
    "ctaTitle": "Βάλτε την AI να δουλέψει — μην την κολλάτε απλώς.",
    "ctaBody": "Πείτε μας πού χάνει τον περισσότερο χρόνο η ομάδα σας. Θα σας δείξουμε ακριβώς πού η AI χτισμένη στο λογισμικό σας θα έκανε πραγματική δουλειά."
  },
  {
    "slug": "custom-software-fixed-price",
    "eyebrow": "// σταθερή_τιμή",
    "title": "Δικό σου λογισμικό σε [[σταθερή τιμή.]]",
    "subtitle": "Το να φτιάξεις δικό σου λογισμικό ακούγεται ακριβό και περίπλοκο. Δεν είναι. Μία σταθερή τιμή, συμφωνημένη από την αρχή, κι ένας σταθερός υπεύθυνος επικοινωνίας από το πρώτο τηλεφώνημα μέχρι το λανσάρισμα – χωρίς εκπλήξεις χρέωσης ανά ώρα, χωρίς το πινγκ-πονγκ των μεγάλων εταιρειών.",
    "metaTitle": "Λογισμικό σε σταθερή τιμή – σταθερός υπεύθυνος | DevCore",
    "metaDescription": "Νομίζεις ότι το custom λογισμικό είναι ακριβό και περίπλοκο; Δεν είναι. Η DevCore το φτιάχνει σε σταθερή τιμή συμφωνημένη από την αρχή, με έναν σταθερό υπεύθυνο από την αρχή ως το τέλος.",
    "stats": [
      { "value": "€ σταθερά", "label": "τιμή συμφωνημένη πριν ξεκινήσουμε" },
      { "value": "1", "label": "σταθερός υπεύθυνος, αρχή ως τέλος" },
      { "value": "0", "label": "εκπλήξεις χρέωσης ανά ώρα" }
    ],
    "problemKicker": "// ο_φόβος",
    "problemTitle": "Το custom λογισμικό έχει μια φήμη – και τρομάζει τον κόσμο",
    "problemBody": "Οι περισσότεροι νομίζουν ότι το δικό τους λογισμικό σημαίνει προϋπολογισμό χωρίς όριο, ένα έργο που τραβάει έναν χρόνο, και συνεχώς νέους αγνώστους που δεν καταλαβαίνουν ποτέ τη δουλειά σου. Έτσι δουλεύουν οι μεγάλες εταιρείες. Εμείς δεν δουλεύουμε έτσι.",
    "problemPoints": [
      "Ανοιχτές προσφορές που μεγαλώνουν κάθε μήνα",
      "Καμία ιδέα για το τι θα γράφει ο τελικός λογαριασμός",
      "Διαφορετικός υπεύθυνος κάθε λίγες εβδομάδες",
      "Τεχνική ορολογία αντί για ξεκάθαρες απαντήσεις",
      "Η αίσθηση ότι είναι μόνο για μεγάλες εταιρείες με μεγάλο μπάτζετ"
    ],
    "pillarsKicker": "// πώς_το_κάνουμε",
    "pillarsTitle": "Προβλέψιμα, προσωπικά και σχεδιασμένα και για μικρότερες επιχειρήσεις",
    "pillars": [
      {
        "icon": "FileText",
        "title": "Μία σταθερή τιμή, συμφωνημένη πρώτα",
        "body": "Πριν γράψουμε μία γραμμή κώδικα, παίρνεις ξεκάθαρο αντικείμενο και μία σταθερή τιμή. Εγκρίνεις – κι αυτό ακριβώς πληρώνεις. Κανένας μετρητής ωρών στο παρασκήνιο."
      },
      {
        "icon": "Eye",
        "title": "Ένας υπεύθυνος που σε ξέρει",
        "body": "Μιλάς με το ίδιο άτομο από το πρώτο τηλεφώνημα ως το λανσάρισμα. Ξέρει τη δουλειά σου, τους στόχους σου και το έργο σου – χωρίς να σε περνούν από χέρι σε χέρι."
      },
      {
        "icon": "Gauge",
        "title": "Ξεκάθαρα, όχι περίπλοκα",
        "body": "Μεταφράζουμε την τεχνολογία σε απλή γλώσσα κι ένα απλό πλάνο. Πάντα καταλαβαίνεις τι φτιάχνεται, γιατί και πόσο κοστίζει."
      },
      {
        "icon": "Rocket",
        "title": "Στα μέτρα της επιχείρησής σου",
        "body": "Σχεδιάζουμε στις πραγματικές σου ανάγκες και στο μπάτζετ σου – ξεκίνα λιτά, απόδειξε την αξία, μετά μεγάλωσε. Το custom λογισμικό δεν είναι πια μόνο για κολοσσούς."
      }
    ],
    "compareKicker": "// σύγκριση",
    "compareTitle": "Τυπική εταιρεία vs. σταθερή τιμή με τη DevCore",
    "compareLeftLabel": "Τυπική εταιρεία",
    "compareRightLabel": "DevCore",
    "compareRows": [
      { "label": "Τιμή", "left": "Ανά ώρα, ανοιχτή", "right": "Σταθερή, συμφωνημένη από την αρχή" },
      { "label": "Υπεύθυνος", "left": "Συνεχώς αλλάζει", "right": "Ένα άτομο, αρχή ως τέλος" },
      { "label": "Μπάτζετ", "left": "Μεγαλώνει στη μέση", "right": "Ό,τι εγκρίνεις, πληρώνεις" },
      { "label": "Γλώσσα", "left": "Τεχνική ορολογία", "right": "Απλή και ξεκάθαρη" },
      { "label": "Μέγεθος έργου", "left": "Για μεγάλα μπάτζετ", "right": "Στα μέτρα σου" },
      { "label": "Ιδιοκτησία", "left": "Δεμένο σε αυτούς", "right": "Ο κώδικας είναι δικός σου" }
    ],
    "processKicker": "// πώς_λειτουργεί",
    "processTitle": "Από την ιδέα στη σταθερή προσφορά – σε μέρες, όχι μήνες",
    "steps": [
      { "title": "Δωρεάν πρώτη κλήση", "body": "Πες μας τι χρειάζεσαι. Ακούμε και κάνουμε τις σωστές ερωτήσεις – χωρίς δέσμευση, χωρίς ορολογία." },
      { "title": "Προσφορά σταθερής τιμής", "body": "Παίρνεις ξεκάθαρο αντικείμενο και μία σταθερή τιμή, σε απλή γλώσσα, πριν φτιαχτεί οτιδήποτε." },
      { "title": "Το φτιάχνουμε", "body": "Ο σταθερός σου υπεύθυνος σε κρατά ενήμερο κάθε εβδομάδα με λογισμικό που δουλεύει." },
      { "title": "Λανσάρισμα & υποστήριξη", "body": "Το βγάζουμε live, σου δίνουμε τα κλειδιά και μένουμε διαθέσιμοι – ίδιο άτομο, ίδιο τηλέφωνο." }
    ],
    "faqKicker": "// ερωτήσεις",
    "faqTitle": "Λογισμικό σε σταθερή τιμή – απαντήσεις",
    "faqs": [
      { "q": "Είναι το custom λογισμικό πραγματικά προσιτό για μια μικρή επιχείρηση;", "a": "Ναι, πιο συχνά απ' όσο νομίζει ο κόσμος. Σχεδιάζουμε στις πραγματικές σου ανάγκες και στο μπάτζετ σου – μπορούμε να ξεκινήσουμε με μια εστιασμένη πρώτη έκδοση που αποδεικνύει την αξία της και μετά να μεγαλώσουμε. Δεν πληρώνεις τιμές μεγάλης εταιρείας." },
      { "q": "Τι ακριβώς σημαίνει 'σταθερή τιμή';", "a": "Συμφωνούμε το αντικείμενο και την τιμή πριν γραφτεί μία γραμμή κώδικα. Όσο δεν αλλάζει το αντικείμενο, αυτή είναι η τιμή που πληρώνεις – χωρίς μετρητή ωρών, χωρίς έκπληξη στο τέλος." },
      { "q": "Κι αν δεν είμαι καθόλου τεχνικός;", "a": "Τέλεια – οι περισσότεροι πελάτες μας δεν είναι. Εξηγείς τη δουλειά σου με απλά λόγια, εμείς παίρνουμε κάθε τεχνική απόφαση και σ' την εξηγούμε απλά." },
      { "q": "Με ποιον θα συνεργάζομαι;", "a": "Με έναν σταθερό υπεύθυνο, από την πρώτη κλήση ως το λανσάρισμα και μετά. Ξέρει το έργο σου απ' έξω κι ανακατωτά, δεν χρειάζεται να εξηγείς ξανά." },
      { "q": "Πόσο γρήγορα μπορούμε να ξεκινήσουμε;", "a": "Η πρώτη κλήση μπορεί να γίνει αυτή την εβδομάδα, και προσφορά σταθερής τιμής έχεις μέσα σε λίγες μέρες. Το χτίσιμο ξεκινά συνήθως λίγο μετά την έγκρισή σου." }
    ],
    "ctaTitle": "Πάρε μια σταθερή τιμή – πριν δεσμευτείς σε οτιδήποτε.",
    "ctaBody": "Πες μας τι θες να φτιάξεις. Θα πάρεις ένα ξεκάθαρο πλάνο και μία σταθερή τιμή, χωρίς δέσμευση και χωρίς ορολογία.",
    "adLanding": true
  },
  {
    "slug": "your-idea-we-build",
    "eyebrow": "// εσύ_εξηγείς_εμείς_φτιάχνουμε",
    "title": "Έχεις την ιδέα. [[Έχουμε την τεχνική ομάδα.]]",
    "subtitle": "Δεν χρειάζεται να είσαι τεχνικός για να φτιάξεις λογισμικό. Εσύ εξηγείς τι θέλεις, εμείς το φτιάχνουμε – ξεκάθαρα, οργανωμένα και προβλέψιμα, χωρίς δική σου ομάδα προγραμματιστών.",
    "metaTitle": "Εσύ εξηγείς, εμείς φτιάχνουμε – λογισμικό χωρίς τεχνική ομάδα | DevCore",
    "metaDescription": "Έχεις ιδέα για λογισμικό αλλά όχι τεχνική ομάδα; Η DevCore είναι η ομάδα σου. Εσύ εξηγείς, εμείς φτιάχνουμε – ξεκάθαρα, οργανωμένα και προβλέψιμα, χωρίς τεχνικό υπόβαθρο.",
    "stats": [
      { "value": "0", "label": "προγραμματιστές που πρέπει να προσλάβεις" },
      { "value": "1", "label": "ομάδα που αναλαμβάνει όλη την τεχνική" },
      { "value": "100%", "label": "δικό σου όταν τελειώσει" }
    ],
    "problemKicker": "// το_κενό",
    "problemTitle": "Μια καλή ιδέα δεν αξίζει τίποτα χωρίς ομάδα να τη φτιάξει",
    "problemBody": "Βλέπεις ακριβώς τι πρέπει να κάνει το λογισμικό. Το πρόβλημα είναι το κενό ανάμεσα στην ιδέα στο μυαλό σου και στο λογισμικό που δουλεύει – και το να προσλάβεις προγραμματιστές, να τους διαχειριστείς και να ξέρεις αν είναι καλοί είναι δουλειά από μόνη της. Αυτό ακριβώς το αναλαμβάνουμε εμείς.",
    "problemPoints": [
      "Κανένας τεχνικός συνιδρυτής ή εσωτερικοί προγραμματιστές",
      "Κανένας τρόπος να κρίνεις αν ένας freelancer είναι όντως καλός",
      "Η ιδέα κολλημένη μήνες στο μυαλό σου (ή σε μια διαφάνεια)",
      "Προσφορές που δεν μπορείς να αξιολογήσεις και χρονοδιαγράμματα που δεν εμπιστεύεσαι",
      "Ο φόβος ότι θα πληρώσεις για κάτι που δεν θα βγει ποτέ"
    ],
    "pillarsKicker": "// τι_αναλαμβάνουμε",
    "pillarsTitle": "Εσύ φέρνεις το όραμα. Εμείς φέρνουμε όλα τα υπόλοιπα.",
    "pillars": [
      {
        "icon": "Eye",
        "title": "Εσύ εξηγείς, με απλά λόγια",
        "body": "Χωρίς προδιαγραφές, χωρίς διαγράμματα. Περιγράφεις τι θες να κάνει, εμείς το μετατρέπουμε σε ξεκάθαρο πλάνο που μπορείς πραγματικά να διαβάσεις."
      },
      {
        "icon": "Code2",
        "title": "Είμαστε η τεχνική σου ομάδα",
        "body": "Σχεδιασμός, ανάπτυξη, υποδομή, έλεγχοι – μια πλήρης έμπειρη ομάδα, χωρίς προσλήψεις, διαχείριση ή μισθούς."
      },
      {
        "icon": "FileText",
        "title": "Ξεκάθαρα και οργανωμένα",
        "body": "Παίρνεις αντικείμενο, χρονοδιάγραμμα και τιμή από την αρχή, μετά λογισμικό που δουλεύει κάθε εβδομάδα. Πάντα ξέρεις πού βρίσκεται το έργο."
      },
      {
        "icon": "Rocket",
        "title": "Προβλέψιμα, όχι τζόγος",
        "body": "Χτίζουμε σε μικρά, ορατά βήματα που μπορείς να κατευθύνεις – ποτέ μήνες σιωπής με έκπληξη στο τέλος."
      }
    ],
    "compareKicker": "// σύγκριση",
    "compareTitle": "Να προσλάβεις ομάδα vs. να μας αφήσεις να το φτιάξουμε",
    "compareLeftLabel": "Πρόσληψη προγραμματιστών",
    "compareRightLabel": "Εσύ εξηγείς, εμείς φτιάχνουμε",
    "compareRows": [
      { "label": "Ξεκίνημα", "left": "Ψάξιμο, έλεγχος, διαχείριση", "right": "Μία κλήση για να ξεκινήσεις" },
      { "label": "Ικανότητα", "left": "Ελπίζεις να είναι καλοί", "right": "Αποδεδειγμένη έμπειρη ομάδα" },
      { "label": "Κόστος", "left": "Μισθοί & έξοδα", "right": "Μία συμφωνημένη τιμή" },
      { "label": "Ο ρόλος σου", "left": "Διαχείριση προγραμματιστών", "right": "Μόνο εξηγείς & εγκρίνεις" },
      { "label": "Ρίσκο", "left": "Το σηκώνεις μόνος", "right": "Το σηκώνουμε μαζί σου" },
      { "label": "Αποτέλεσμα", "left": "Αν βγει", "right": "Λογισμικό που δουλεύει και σου ανήκει" }
    ],
    "processKicker": "// πώς_λειτουργεί",
    "processTitle": "Από το 'έχω μια ιδέα' σε ζωντανό λογισμικό",
    "steps": [
      { "title": "Πες μας την ιδέα", "body": "Μια χαλαρή πρώτη κλήση όπου εξηγείς τι θες – σε καθημερινή γλώσσα, χωρίς τεχνικά." },
      { "title": "Το σχεδιάζουμε", "body": "Το μετατρέπουμε σε ξεκάθαρο blueprint: τι κάνει, πόσο κρατά, πόσο κοστίζει. Εσύ εγκρίνεις." },
      { "title": "Το φτιάχνουμε", "body": "Το λογισμικό σου χτίζεται σε εβδομαδιαία βήματα που βλέπεις, δοκιμάζεις και διαμορφώνεις." },
      { "title": "Είναι δικό σου", "body": "Το βγάζουμε live, σου το παραδίδουμε και μένουμε για υποστήριξη κι ανάπτυξη." }
    ],
    "faqKicker": "// ερωτήσεις",
    "faqTitle": "Εσύ εξηγείς, εμείς φτιάχνουμε – απαντήσεις",
    "faqs": [
      { "q": "Δεν είμαι καθόλου τεχνικός. Είναι πρόβλημα;", "a": "Καθόλου – για εμάς είναι ο κανόνας. Εξηγείς την ιδέα σου σε απλή γλώσσα κι εμείς παίρνουμε κάθε τεχνική απόφαση, κρατώντας σε ενήμερο με λόγια που καταλαβαίνεις." },
      { "q": "Πρέπει να γράψω προδιαγραφές ή έγγραφο απαιτήσεων;", "a": "Όχι. Μια συζήτηση αρκεί για ξεκίνημα. Μετατρέπουμε αυτά που μας λες σε ξεκάθαρο blueprint και το βελτιώνουμε μαζί σου – δεν χρειάζεται να ξέρεις την ορολογία." },
      { "q": "Πώς ξέρω ότι το λογισμικό θα φτιαχτεί όντως;", "a": "Γιατί το βλέπεις να μεγαλώνει κάθε εβδομάδα, όχι στο τέλος. Χτίζουμε σε μικρά, ορατά βήματα, η πρόοδος είναι πραγματική και δεν μένεις ποτέ στην αβεβαιότητα." },
      { "q": "Θα μου ανήκει ή θα είμαστε δεμένοι μαζί σας;", "a": "Σου ανήκει εξ ολοκλήρου – ο κώδικας, τα δεδομένα, τα πάντα. Μπορούμε να συνεχίσουμε την υποστήριξη αν θες, αλλά δεν είσαι ποτέ δεμένος." },
      { "q": "Πόσο κοστίζει και πόσο κρατά;", "a": "Παίρνεις τιμή και χρονοδιάγραμμα από την αρχή, πριν χτίσουμε. Μια εστιασμένη πρώτη έκδοση είναι συνήθως live σε λίγες εβδομάδες." }
    ],
    "ctaTitle": "Πες μας την ιδέα. Την τεχνική την αναλαμβάνουμε εμείς.",
    "ctaBody": "Περίγραψε το λογισμικό που θα ήθελες να υπάρχει. Θα το κάνουμε ξεκάθαρο πλάνο – και μετά πραγματικότητα.",
    "adLanding": true
  }
,
  {
    "slug": "custom-software-development",
    "eyebrow": "// built_for_you",
    "title": "Ανάπτυξη προσαρμοσμένου λογισμικού – [[χτισμένου γύρω από τις διαδικασίες σας.]]",
    "subtitle": "Το τυποποιημένο λογισμικό αναγκάζει την επιχείρησή σας να προσαρμοστεί. Το προσαρμοσμένο λογισμικό κάνει το αντίθετο: κάθε οθόνη, κανόνας και σύνδεση ακολουθεί τον τρόπο που δουλεύετε – και το αποτέλεσμα σας ανήκει.",
    "metaTitle": "Ανάπτυξη Προσαρμοσμένου Λογισμικού για τις Διαδικασίες σας | DevCore",
    "metaDescription": "Αναπτύξτε προσαρμοσμένο λογισμικό που ταιριάζει ακριβώς στις διαδικασίες σας: web εφαρμογές, πύλες, CRM και εσωτερικά εργαλεία. Διαφανή εύρη τιμών, πλήρης ιδιοκτησία.",
    "stats": [
      { "value": "3-16", "label": "εβδομάδες έως το λανσάρισμα, ανά είδος έργου" },
      { "value": "100%", "label": "ιδιοκτησία κώδικα & δεδομένων" },
      { "value": "0", "label": "κόστος άδειας ανά χρήστη" }
    ],
    "problemKicker": "// the_gap",
    "problemTitle": "Το έτοιμο λογισμικό καλύπτει το 70%. Το υπόλοιπο 30% σας κοστίζει κάθε μέρα.",
    "problemBody": "Υπολογιστικά φύλλα δίπλα στο CRM. Αντιγραφή-επικόλληση μεταξύ πέντε εργαλείων. Μια διαδικασία που δουλεύει μόνο επειδή ένα άτομο ξέρει όλες τις παρακάμψεις. Δεν είναι θέμα εκπαίδευσης – το λογισμικό απλώς δεν ταιριάζει στην επιχείρηση.",
    "problemPoints": [
      "Διπλή καταχώρηση δεδομένων μεταξύ συστημάτων που δεν επικοινωνούν",
      "Διαδικασίες προσαρμοσμένες στο εργαλείο αντί του αντίστροφου",
      "Το reporting παίρνει ώρες γιατί τα δεδομένα είναι σε πέντε σημεία",
      "Κόστος αδειών που αυξάνεται με κάθε νέο συνάδελφο",
      "Κρίσιμη γνώση κλειδωμένη σε φύλλα και εισερχόμενα"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Εξατομικευμένες λύσεις λογισμικού που αντικατοπτρίζουν την επιχείρησή σας",
    "pillars": [
      {
        "icon": "Workflow",
        "title": "Οι διαδικασίες σας 1:1",
        "body": "Μοντελοποιούμε πώς δουλεύει πραγματικά η επιχείρησή σας – ρόλοι, εγκρίσεις, εξαιρέσεις – αντί να τη στριμώξουμε σε ένα πρότυπο."
      },
      {
        "icon": "Boxes",
        "title": "Συνδεδεμένο με το stack σας",
        "body": "ERP, CRM, λογιστική, email, αποθήκη – το νέο σύστημα συνδέεται με ό,τι χρησιμοποιείτε ήδη, ώστε τα δεδομένα να καταχωρούνται μία φορά."
      },
      {
        "icon": "FileText",
        "title": "Σαφείς προδιαγραφές, προβλέψιμη τιμή",
        "body": "Σε μια φάση σχεδιασμού ξεκαθαρίζουμε αναλυτικά απαιτήσεις, ρόλους και διασυνδέσεις. Μετά ορίζονται προδιαγραφές, χρονοδιάγραμμα και τιμή – πριν ξεκινήσει η ανάπτυξη."
      },
      {
        "icon": "Lock",
        "title": "Όλα σας ανήκουν",
        "body": "Πηγαίος κώδικας, δεδομένα, υποδομή. Χωρίς εξάρτηση, χωρίς τιμολόγηση ανά χρήστη, χωρίς προμηθευτή που ορίζει το roadmap σας."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Τυποποιημένο λογισμικό vs. προσαρμοσμένη ανάπτυξη",
    "compareLeftLabel": "Έτοιμο εργαλείο",
    "compareRightLabel": "Προσαρμοσμένο λογισμικό",
    "compareRows": [
      { "label": "Ταίριασμα στη διαδικασία", "left": "Προσαρμόζεστε εσείς", "right": "Προσαρμόζεται αυτό" },
      { "label": "Μοντέλο κόστους", "left": "Ανά χρήστη, για πάντα", "right": "Εφάπαξ επένδυση" },
      { "label": "Συνδέσεις", "left": "Ό,τι προσφέρεται", "right": "Ό,τι χρειάζεστε" },
      { "label": "Δεδομένα", "left": "Σε ξένη πλατφόρμα", "right": "Δικά σας" },
      { "label": "Roadmap", "left": "Αποφασίζει άλλος", "right": "Αποφασίζετε εσείς" },
      { "label": "Ανάπτυξη", "left": "Γίνεται πιο ακριβό", "right": "Γίνεται πιο πολύτιμο" }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Από την απαίτηση στο λειτουργικό σύστημα",
    "steps": [
      { "title": "Δωρεάν blueprint", "body": "Περιγράψτε την ιδέα σας – παίρνετε roadmap, tech stack και προδιαγραφές, χωρίς κόστος." },
      { "title": "Φάση σχεδιασμού & σταθερή τιμή", "body": "Μαζί ορίζουμε αναλυτικά ροές, ρόλους και διασυνδέσεις. Το αποτέλεσμα είναι δεσμευτικές προδιαγραφές με χρονοδιάγραμμα και σταθερή τιμή." },
      { "title": "Ανάπτυξη σε sprints", "body": "Κάθε δύο εβδομάδες βλέπετε λειτουργικό λογισμικό και το κατευθύνετε." },
      { "title": "Λανσάρισμα & εξέλιξη", "body": "Πρώτα live, μετά επέκταση module με module όσο μεγαλώνει η επιχείρηση." }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Ανάπτυξη προσαρμοσμένου λογισμικού – συχνές ερωτήσεις",
    "faqs": [
      {
        "q": "Πόσο κοστίζει το προσαρμοσμένο λογισμικό;",
        "a": "Εξαρτάται από το αντικείμενο. Τυπικά εύρη: εσωτερικά εργαλεία από περίπου 15.000 €, πύλες πελατών 30.000–55.000 €, custom CRM 35.000–70.000 €, πλατφόρμες SaaS (MVP) 50.000–95.000 €. Δεσμευτική σταθερή τιμή δίνουμε μετά από μια κοινή φάση σχεδιασμού, όταν το αντικείμενο έχει πραγματικά οριστεί. Όλα τα εύρη θα τα βρείτε στη σελίδα κόστους."
      },
      {
        "q": "Πόσο διαρκεί η ανάπτυξη;",
        "a": "Τα μικρά εργαλεία γίνονται συνήθως live σε τρεις έως έξι εβδομάδες, οι πύλες και τα CRM σε έξι έως 14 εβδομάδες, μια πλατφόρμα SaaS (MVP) σε δέκα έως 16 εβδομάδες. Παραδίδουμε σε sprints, ώστε να δουλεύετε νωρίς με πραγματικό λογισμικό."
      },
      {
        "q": "Τι είδους συστήματα φτιάχνετε;",
        "a": "Web εφαρμογές, πύλες πελατών και συνεργατών, CRM, επεκτάσεις ERP, εσωτερικά εργαλεία, dashboards, συστήματα κρατήσεων και προσφορών, και ροές με AI."
      },
      {
        "q": "Μπορεί να συνδεθεί με τα υπάρχοντα συστήματά μας;",
        "a": "Ναι. Συνδέουμε ERP, CRM, λογιστική, email, πληρωμές και αποθήκη μέσω API, ώστε τα δεδομένα να καταχωρούνται μία φορά και να χρησιμοποιούνται παντού."
      },
      {
        "q": "Σε ποιον ανήκει ο πηγαίος κώδικας;",
        "a": "Σε εσάς – πλήρως. Κώδικας, δεδομένα και υποδομή είναι δικά σας, μαζί με την τεκμηρίωση, ώστε να μην εξαρτάστε από κανέναν πάροχο."
      },
      {
        "q": "Πώς ξεκινάμε;",
        "a": "Με το δωρεάν blueprint: περιγράψτε την ιδέα σας σε λίγες προτάσεις και λάβετε roadmap, tech stack και προδιαγραφές. Χωρίς δέσμευση."
      }
    ],
    "ctaTitle": "Πάρτε τις προδιαγραφές σας – δωρεάν.",
    "ctaBody": "Περιγράψτε την απαίτησή σας σε λίγες προτάσεις. Παίρνετε roadmap, tech stack και προδιαγραφές που μπορείτε να χρησιμοποιήσετε – με ή χωρίς εμάς."
  },

  {
    "slug": "software-development-agency",
    "eyebrow": "// your_partner",
    "title": "Μια εταιρεία ανάπτυξης λογισμικού που [[παραδίδει – δεν παρουσιάζει μόνο.]]",
    "subtitle": "Κανένας account manager ανάμεσα σε εσάς και τους developers. Μια μικρή senior ομάδα, σαφές αντικείμενο, σταθερή τιμή και λειτουργικό λογισμικό κάθε δύο εβδομάδες. Αυτό είναι όλο το μοντέλο.",
    "metaTitle": "Εταιρεία Ανάπτυξης Λογισμικού για Επιχειρηματικό Λογισμικό | DevCore",
    "metaDescription": "Ψάχνετε εταιρεία ανάπτυξης λογισμικού; Η DevCore φτιάχνει προσαρμοσμένο επιχειρηματικό λογισμικό με senior ομάδα, σταθερή τιμή και release κάθε δύο εβδομάδες.",
    "stats": [
      { "value": "2", "label": "εβδομάδες ανά release" },
      { "value": "1", "label": "άμεση επαφή, χωρίς επίπεδα" },
      { "value": "0", "label": "απρόσμενα τιμολόγια" }
    ],
    "problemKicker": "// the_agency_problem",
    "problemTitle": "Τα περισσότερα έργα με εταιρείες αποτυγχάνουν πριν γραφτεί η πρώτη γραμμή κώδικα.",
    "problemBody": "Λαμπερή παρουσίαση, μετά juniors στην υλοποίηση. Απαιτήσεις που μετατρέπονται σε change requests. Προϋπολογισμοί που διπλασιάζονται. Αποτέλεσμα: ένα σύστημα που κανείς δεν θέλει να αναλάβει. Η λύση δεν είναι μεγαλύτερη εταιρεία, αλλά μικρότερη με πραγματική ευθύνη.",
    "problemPoints": [
      "Seniors στην παρουσίαση, juniors στην υλοποίηση",
      "Κάθε διευκρίνιση γίνεται χρεώσιμο change request",
      "Μήνες σιωπής και μετά ένα demo εκτός στόχου",
      "Μετά το έργο κανείς δεν μπορεί να εξηγήσει τον κώδικα",
      "Χρέωση με την ώρα, χωρίς ανώτατο όριο"
    ],
    "pillarsKicker": "// how_we_work",
    "pillarsTitle": "Πώς είναι πραγματικά η συνεργασία",
    "pillars": [
      {
        "icon": "Target",
        "title": "Απευθείας με τους developers",
        "body": "Μιλάτε με τους ανθρώπους που γράφουν τον κώδικα. Χωρίς επίπεδο account, χωρίς χαμένο πλαίσιο."
      },
      {
        "icon": "FileText",
        "title": "Γραπτές προδιαγραφές, σταθερή τιμή",
        "body": "Αντικείμενο, χρονοδιάγραμμα και τιμή συμφωνούνται εξ αρχής. Οι αλλαγές συζητούνται ανοιχτά."
      },
      {
        "icon": "Gauge",
        "title": "Λειτουργικό λογισμικό κάθε 2 εβδομάδες",
        "body": "Βλέπετε την πρόοδο συνεχώς και διορθώνετε νωρίς – τη φθηνότερη στιγμή για κάθε αλλαγή."
      },
      {
        "icon": "ShieldCheck",
        "title": "Παράδοση, όχι εξάρτηση",
        "body": "Τεκμηριωμένος κώδικας, τα repositories σας, η υποδομή σας. Συνεχίζετε με εμάς, εσωτερικά ή αλλού."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Κλασική εταιρεία vs. DevCore",
    "compareLeftLabel": "Κλασική εταιρεία",
    "compareRightLabel": "DevCore",
    "compareRows": [
      { "label": "Επαφή", "left": "Account manager", "right": "Οι developers" },
      { "label": "Τιμολόγηση", "left": "Ωριαία, ανοιχτή", "right": "Σταθερή, εξ αρχής" },
      { "label": "Ομάδα", "left": "Seniors παρουσιάζουν, juniors φτιάχνουν", "right": "Seniors φτιάχνουν" },
      { "label": "Πρόοδος", "left": "Demos ανά milestone", "right": "Κάθε δύο εβδομάδες" },
      { "label": "Κώδικας", "left": "Δικό τους repo", "right": "Δικός σας, τεκμηριωμένος" },
      { "label": "Αλλαγές", "left": "Change request", "right": "Συζήτηση" }
    ],
    "processKicker": "// engagement",
    "processTitle": "Πώς τρέχει ένα έργο μαζί μας",
    "steps": [
      { "title": "Δωρεάν blueprint", "body": "Περιγράφετε το έργο, επιστρέφουμε roadmap, tech stack και προδιαγραφές." },
      { "title": "Πρώτη κλήση", "body": "30 λεπτά για εφικτότητα, ρίσκα και τι θα κάναμε διαφορετικά." },
      { "title": "Σταθερή προσφορά", "body": "Δεσμευτικό αντικείμενο, χρονοδιάγραμμα και τιμή – αποφασίζετε με πλήρη εικόνα." },
      { "title": "Υλοποίηση & παράδοση", "body": "Releases κάθε δύο εβδομάδες, μετά τεκμηριωμένη παράδοση και προαιρετική υποστήριξη." }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Συνεργασία με εταιρεία λογισμικού – συχνές ερωτήσεις",
    "faqs": [
      {
        "q": "Τι έργα αναλαμβάνετε;",
        "a": "Προσαρμοσμένο επιχειρηματικό λογισμικό: web εφαρμογές, πύλες πελατών και συνεργατών, CRM, εσωτερικά εργαλεία, διασυνδέσεις και ροές με AI. Συνήθως για εταιρείες 10 έως 500 εργαζομένων."
      },
      {
        "q": "Δουλεύετε remote ή on site;",
        "a": "Κυρίως remote με δομημένες, τακτικές κλήσεις. Workshops on site είναι εφικτά για kick-off ή σύνθετη χαρτογράφηση διαδικασιών."
      },
      {
        "q": "Πώς διαχειρίζεστε αλλαγές στις απαιτήσεις;",
        "a": "Οι απαιτήσεις αλλάζουν πάντα. Σχεδιάζουμε σε sprints, ώστε οι αλλαγές να μπαίνουν στο επόμενο sprint και όχι σε συμβατική διαμάχη."
      },
      {
        "q": "Τι γίνεται μετά το λανσάρισμα;",
        "a": "Επιλέγετε: συμφωνία υποστήριξης και εξέλιξης, ή πλήρης παράδοση με τεκμηρίωση ώστε η ομάδα σας να συνεχίσει μόνη."
      },
      {
        "q": "Γιατί είναι πλεονέκτημα η μικρή ομάδα;",
        "a": "Λιγότερες μεταβιβάσεις, χωρίς εσωτερικές κλιμακώσεις, seniors στην ουσιαστική δουλειά. Γι' αυτό το πρώτο release παίρνει εβδομάδες, όχι τρίμηνα."
      }
    ],
    "ctaTitle": "Ας δούμε το έργο σας – δωρεάν.",
    "ctaBody": "Περιγράψτε τι θέλετε να φτιάξετε. Παίρνετε roadmap, tech stack και προδιαγραφές – μετά αποφασίζετε αν θα το υλοποιήσουμε."
  }
];
